var map = {
	"./adults": 29,
	"./adults.png": 29,
	"./apparels/Dachhsund-Full-Set-hoodie": 30,
	"./apparels/Dachhsund-Full-Set-hoodie.jpg": 30,
	"./apparels/Dachhsund-Full-Set-pillow": 31,
	"./apparels/Dachhsund-Full-Set-pillow.jpg": 31,
	"./apparels/Dachhsund-Full-Set-travel-mug": 32,
	"./apparels/Dachhsund-Full-Set-travel-mug.jpg": 32,
	"./braintrainingfordogs": 33,
	"./braintrainingfordogs.jpg": 33,
	"./cats/all-absorb": 34,
	"./cats/all-absorb.jpg": 34,
	"./cats/cat-pregnancy-calculator-feline-estrus": 35,
	"./cats/cat-pregnancy-calculator-feline-estrus.jpg": 35,
	"./cats/cat-pregnancy-calculator-postpartum": 36,
	"./cats/cat-pregnancy-calculator-postpartum.jpg": 36,
	"./cats/cat-pregnancy-calculator-queening": 37,
	"./cats/cat-pregnancy-calculator-queening.jpg": 37,
	"./cats/cat-pregnancy-calculator-week-1": 38,
	"./cats/cat-pregnancy-calculator-week-1.jpg": 38,
	"./cats/cat-pregnancy-calculator-week-2": 39,
	"./cats/cat-pregnancy-calculator-week-2.jpg": 39,
	"./cats/cat-pregnancy-calculator-week-5": 40,
	"./cats/cat-pregnancy-calculator-week-5.jpg": 40,
	"./cats/cat-pregnancy-calculator-week-6-and-7": 41,
	"./cats/cat-pregnancy-calculator-week-6-and-7.jpg": 41,
	"./cats/cat-pregnancy-calculator-week-8": 42,
	"./cats/cat-pregnancy-calculator-week-8.jpg": 42,
	"./cats/cat-pregnancy-calculator-week-9-and-10": 43,
	"./cats/cat-pregnancy-calculator-week-9-and-10.jpg": 43,
	"./cats/purina-one-healthy-kitten-food": 44,
	"./cats/purina-one-healthy-kitten-food.png": 44,
	"./chocolate-toxic-calculator": 45,
	"./chocolate-toxic-calculator.png": 45,
	"./cows/30 day old cow fetus": 46,
	"./cows/30 day old cow fetus.jpg": 46,
	"./cows/Cow at 9 months pregnancy": 47,
	"./cows/Cow at 9 months pregnancy.jpg": 47,
	"./cows/Cow fetus at 2 months": 48,
	"./cows/Cow fetus at 2 months.jpg": 48,
	"./cows/Cow fetus at 3 months": 49,
	"./cows/Cow fetus at 3 months.jpg": 49,
	"./cows/Cow fetus at 7 months": 50,
	"./cows/Cow fetus at 7 months.jpg": 50,
	"./cows/Cow in postpartum period caring for newborn calves": 51,
	"./cows/Cow in postpartum period caring for newborn calves.jpeg": 51,
	"./cows/Cow in stage 2 of labor": 52,
	"./cows/Cow in stage 2 of labor.jpg": 52,
	"./cows/Enlarged cow udders": 53,
	"./cows/Enlarged cow udders.jpg": 53,
	"./cows/Pregnant cow in second trimester": 54,
	"./cows/Pregnant cow in second trimester.jpg": 54,
	"./custom-ads/amazon": 55,
	"./custom-ads/amazon.svg": 55,
	"./custom-ads/chewy": 56,
	"./custom-ads/chewy.svg": 56,
	"./custom-ads/embark": 57,
	"./custom-ads/embark.png": 57,
	"./default_avatar": 58,
	"./default_avatar.jpg": 58,
	"./dog-age-calculator": 59,
	"./dog-age-calculator.png": 59,
	"./dog-name-generator": 60,
	"./dog-name-generator.png": 60,
	"./dog-pregnancy-calculator": 61,
	"./dog-pregnancy-calculator.png": 61,
	"./dogs/chocolate-toxic-calculator-how-much-chocolate-is-toxic-for-your-dogs": 62,
	"./dogs/chocolate-toxic-calculator-how-much-chocolate-is-toxic-for-your-dogs.jpg": 62,
	"./dogs/chocolate-toxic-calculator-how-to-get-the-cocoa-out-of-your-dog-s system": 63,
	"./dogs/chocolate-toxic-calculator-how-to-get-the-cocoa-out-of-your-dog-s system.jpg": 63,
	"./dogs/chocolate-toxic-calculator-what-contributes-to-the-level-of-toxicity-in-your-dogs": 64,
	"./dogs/chocolate-toxic-calculator-what-contributes-to-the-level-of-toxicity-in-your-dogs.jpg": 64,
	"./dogs/chocolate-toxic-calculator-what-factors-determine-the-level-of-toxicity": 65,
	"./dogs/chocolate-toxic-calculator-what-factors-determine-the-level-of-toxicity.jpg": 65,
	"./dogs/chocolate-toxic-calculator-what-happens-if-it-is-consumed-in-large-quantities": 66,
	"./dogs/chocolate-toxic-calculator-what-happens-if-it-is-consumed-in-large-quantities.jpg": 66,
	"./dogs/dog-life-expectancy-calculator-how-about-mixed-breed-dogs": 67,
	"./dogs/dog-life-expectancy-calculator-how-about-mixed-breed-dogs.jpg": 67,
	"./dogs/dog-life-expectancy-calculator-what-determines-a-dog-s-lifespan": 68,
	"./dogs/dog-life-expectancy-calculator-what-determines-a-dog-s-lifespan.jpg": 68,
	"./dogs/dog-pregnancy-giving-birth": 69,
	"./dogs/dog-pregnancy-giving-birth.jpg": 69,
	"./dogs/dog-pregnancy-postnatal": 70,
	"./dogs/dog-pregnancy-postnatal.jpg": 70,
	"./dogs/dog-pregnancy-week4": 71,
	"./dogs/dog-pregnancy-week4.jpg": 71,
	"./dogs/dog-pregnancy-week5": 72,
	"./dogs/dog-pregnancy-week5.jpg": 72,
	"./dogs/dog-pregnancy-week6": 73,
	"./dogs/dog-pregnancy-week6.jpg": 73,
	"./dogs/dog-pregnancy-week7": 74,
	"./dogs/dog-pregnancy-week7.jpg": 74,
	"./dogs/dog-pregnancy-week8": 75,
	"./dogs/dog-pregnancy-week8.jpg": 75,
	"./dogs/dog-pregnancy-week9": 76,
	"./dogs/dog-pregnancy-week9.jpg": 76,
	"./dogs/emergency-vets-usa-24-hour-vets-near-you-emergency-vets-near-you": 77,
	"./dogs/emergency-vets-usa-24-hour-vets-near-you-emergency-vets-near-you.jpg": 77,
	"./dogs/emergency-vets-usa-after-hours-animal-hospitals": 78,
	"./dogs/emergency-vets-usa-after-hours-animal-hospitals.jpg": 78,
	"./dogs/emergency-vets-usa-e-r-vets-open-on-saturday": 79,
	"./dogs/emergency-vets-usa-e-r-vets-open-on-saturday.jpg": 79,
	"./dogs/emergency-vets-usa-local-veterinarian-pet-hospitals": 80,
	"./dogs/emergency-vets-usa-local-veterinarian-pet-hospitals.jpg": 80,
	"./dogs/emergency-vets-usa-our-stringent-requirements-for-emergency-vets": 81,
	"./dogs/emergency-vets-usa-our-stringent-requirements-for-emergency-vets.jpg": 81,
	"./dogs/emergency-vets-usa-search-for-local-emergency-vets-and-animal-hospitals-near-you": 82,
	"./dogs/emergency-vets-usa-search-for-local-emergency-vets-and-animal-hospitals-near-you.jpg": 82,
	"./dogs/emergency-vets-usa-vets-open-on-sunday": 83,
	"./dogs/emergency-vets-usa-vets-open-on-sunday.jpg": 83,
	"./dogs/emergency-vets-usa-walk-in-vet-clinics": 84,
	"./dogs/emergency-vets-usa-walk-in-vet-clinics.jpg": 84,
	"./dogs/mixed_breed_notice": 85,
	"./dogs/mixed_breed_notice.jpg": 85,
	"./dogs/pregnancy/calcium": 86,
	"./dogs/pregnancy/calcium.jpg": 86,
	"./dogs/pregnancy/postnatal-large": 87,
	"./dogs/pregnancy/postnatal-large.jpg": 87,
	"./dogs/pregnancy/postnatal-small": 88,
	"./dogs/pregnancy/postnatal-small.jpg": 88,
	"./dogs/pregnancy/prenatal-large": 89,
	"./dogs/pregnancy/prenatal-large.jpg": 89,
	"./dogs/pregnancy/prenatal-small": 90,
	"./dogs/pregnancy/prenatal-small.jpg": 90,
	"./dogs/pregnancy/royal-canin": 91,
	"./dogs/pregnancy/royal-canin.jpg": 91,
	"./dogs/puppy_height/Affenpinscher": 92,
	"./dogs/puppy_height/Affenpinscher.jpg": 92,
	"./dogs/puppy_height/Afghan Hound": 93,
	"./dogs/puppy_height/Afghan Hound.jpg": 93,
	"./dogs/puppy_height/Airedale Terrier": 94,
	"./dogs/puppy_height/Airedale Terrier.jpg": 94,
	"./dogs/puppy_height/Akita": 95,
	"./dogs/puppy_height/Akita.jpg": 95,
	"./dogs/puppy_height/Alano Español": 96,
	"./dogs/puppy_height/Alano Español.jpg": 96,
	"./dogs/puppy_height/Alaskan Malamute": 97,
	"./dogs/puppy_height/Alaskan Malamute.jpg": 97,
	"./dogs/puppy_height/Alpine Dachsbracke": 98,
	"./dogs/puppy_height/Alpine Dachsbracke.jpg": 98,
	"./dogs/puppy_height/American Akita": 99,
	"./dogs/puppy_height/American Akita.jpg": 99,
	"./dogs/puppy_height/American Bulldog": 100,
	"./dogs/puppy_height/American Bulldog.jpg": 100,
	"./dogs/puppy_height/American Bully": 101,
	"./dogs/puppy_height/American Bully.jpg": 101,
	"./dogs/puppy_height/American Cocker Spaniel": 102,
	"./dogs/puppy_height/American Cocker Spaniel.jpg": 102,
	"./dogs/puppy_height/American Hairless Terrier": 103,
	"./dogs/puppy_height/American Hairless Terrier.jpg": 103,
	"./dogs/puppy_height/American Pit Bull Terrier": 104,
	"./dogs/puppy_height/American Pit Bull Terrier.jpg": 104,
	"./dogs/puppy_height/American Staffordshire Terrier": 105,
	"./dogs/puppy_height/American Staffordshire Terrier.jpg": 105,
	"./dogs/puppy_height/Anatolian Shepherd Dog": 106,
	"./dogs/puppy_height/Anatolian Shepherd Dog.jpg": 106,
	"./dogs/puppy_height/Andalusian Hound (Medium)": 107,
	"./dogs/puppy_height/Andalusian Hound (Medium).jpg": 107,
	"./dogs/puppy_height/Appenzeller Sennenhund": 108,
	"./dogs/puppy_height/Appenzeller Sennenhund.jpg": 108,
	"./dogs/puppy_height/Australian Cattle Dog": 109,
	"./dogs/puppy_height/Australian Cattle Dog.jpg": 109,
	"./dogs/puppy_height/Australian Shepherd": 110,
	"./dogs/puppy_height/Australian Shepherd.jpg": 110,
	"./dogs/puppy_height/Australian Terrier": 111,
	"./dogs/puppy_height/Australian Terrier.jpg": 111,
	"./dogs/puppy_height/Barbado da Terceira": 112,
	"./dogs/puppy_height/Barbado da Terceira.jpg": 112,
	"./dogs/puppy_height/Barbet": 113,
	"./dogs/puppy_height/Barbet.jpg": 113,
	"./dogs/puppy_height/Basenji": 114,
	"./dogs/puppy_height/Basenji.jpg": 114,
	"./dogs/puppy_height/Basset Fauve de Bretagne": 115,
	"./dogs/puppy_height/Basset Fauve de Bretagne.jpg": 115,
	"./dogs/puppy_height/Basset Hound": 116,
	"./dogs/puppy_height/Basset Hound.jpg": 116,
	"./dogs/puppy_height/Beagle": 117,
	"./dogs/puppy_height/Beagle.jpg": 117,
	"./dogs/puppy_height/Bearded Collie": 118,
	"./dogs/puppy_height/Bearded Collie.jpg": 118,
	"./dogs/puppy_height/Beauceron": 119,
	"./dogs/puppy_height/Beauceron.jpg": 119,
	"./dogs/puppy_height/Bedlington Terrier": 120,
	"./dogs/puppy_height/Bedlington Terrier.jpg": 120,
	"./dogs/puppy_height/Belgian Shepherd Dog (Groenendael)": 121,
	"./dogs/puppy_height/Belgian Shepherd Dog (Groenendael).jpg": 121,
	"./dogs/puppy_height/Belgian Shepherd Dog (Laekenois)": 122,
	"./dogs/puppy_height/Belgian Shepherd Dog (Laekenois).jpg": 122,
	"./dogs/puppy_height/Belgian Shepherd Dog (Malinois)": 123,
	"./dogs/puppy_height/Belgian Shepherd Dog (Malinois).jpg": 123,
	"./dogs/puppy_height/Belgian Shepherd Dog (Tervuren)": 124,
	"./dogs/puppy_height/Belgian Shepherd Dog (Tervuren).jpg": 124,
	"./dogs/puppy_height/Berger Blanc Suisse": 125,
	"./dogs/puppy_height/Berger Blanc Suisse.jpg": 125,
	"./dogs/puppy_height/Berger Picard": 126,
	"./dogs/puppy_height/Berger Picard.jpg": 126,
	"./dogs/puppy_height/Bernese Mountain Dog": 127,
	"./dogs/puppy_height/Bernese Mountain Dog.jpg": 127,
	"./dogs/puppy_height/Bichon Frise": 128,
	"./dogs/puppy_height/Bichon Frise.jpg": 128,
	"./dogs/puppy_height/Biewer Terrier": 129,
	"./dogs/puppy_height/Biewer Terrier.jpg": 129,
	"./dogs/puppy_height/Boerboel": 130,
	"./dogs/puppy_height/Boerboel.jpg": 130,
	"./dogs/puppy_height/Bohemian Shepherd": 131,
	"./dogs/puppy_height/Bohemian Shepherd.jpg": 131,
	"./dogs/puppy_height/Bolognese": 132,
	"./dogs/puppy_height/Bolognese.jpg": 132,
	"./dogs/puppy_height/Bolonka Zwetna": 133,
	"./dogs/puppy_height/Bolonka Zwetna.jpg": 133,
	"./dogs/puppy_height/Border Collie": 134,
	"./dogs/puppy_height/Border Collie.jpg": 134,
	"./dogs/puppy_height/Border Terrier": 135,
	"./dogs/puppy_height/Border Terrier.jpg": 135,
	"./dogs/puppy_height/Borzoi": 136,
	"./dogs/puppy_height/Borzoi.jpg": 136,
	"./dogs/puppy_height/Boston Terrier": 137,
	"./dogs/puppy_height/Boston Terrier.jpg": 137,
	"./dogs/puppy_height/Bouvier des Ardennes": 138,
	"./dogs/puppy_height/Bouvier des Ardennes.jpg": 138,
	"./dogs/puppy_height/Bouvier des Flandres": 139,
	"./dogs/puppy_height/Bouvier des Flandres.jpg": 139,
	"./dogs/puppy_height/Boxer": 140,
	"./dogs/puppy_height/Boxer.jpg": 140,
	"./dogs/puppy_height/Braque Francais": 141,
	"./dogs/puppy_height/Braque Francais.jpg": 141,
	"./dogs/puppy_height/Brazilian Terrier": 142,
	"./dogs/puppy_height/Brazilian Terrier.jpg": 142,
	"./dogs/puppy_height/Briard": 143,
	"./dogs/puppy_height/Briard.jpg": 143,
	"./dogs/puppy_height/Brittany": 144,
	"./dogs/puppy_height/Brittany.jpg": 144,
	"./dogs/puppy_height/Brussels Griffon": 145,
	"./dogs/puppy_height/Brussels Griffon.jpg": 145,
	"./dogs/puppy_height/Bucovina Shepherd Dog": 146,
	"./dogs/puppy_height/Bucovina Shepherd Dog.jpg": 146,
	"./dogs/puppy_height/Bull Terrier": 147,
	"./dogs/puppy_height/Bull Terrier (Miniature)": 148,
	"./dogs/puppy_height/Bull Terrier (Miniature).jpg": 148,
	"./dogs/puppy_height/Bull Terrier.jpg": 147,
	"./dogs/puppy_height/Bulldog": 149,
	"./dogs/puppy_height/Bulldog.jpg": 149,
	"./dogs/puppy_height/Bullmastiff": 150,
	"./dogs/puppy_height/Bullmastiff.jpg": 150,
	"./dogs/puppy_height/Cairn Terrier": 151,
	"./dogs/puppy_height/Cairn Terrier.jpg": 151,
	"./dogs/puppy_height/Cane Corso": 152,
	"./dogs/puppy_height/Cane Corso.jpg": 152,
	"./dogs/puppy_height/Cardigan Welsh Corgi": 153,
	"./dogs/puppy_height/Cardigan Welsh Corgi.jpg": 153,
	"./dogs/puppy_height/Catahoula Leopard Dog": 154,
	"./dogs/puppy_height/Catahoula Leopard Dog.jpg": 154,
	"./dogs/puppy_height/Catalan Sheepdog": 155,
	"./dogs/puppy_height/Catalan Sheepdog.jpg": 155,
	"./dogs/puppy_height/Caucasian Shepherd Dog": 156,
	"./dogs/puppy_height/Caucasian Shepherd Dog.jpg": 156,
	"./dogs/puppy_height/Cavalier King Charles Spaniel": 157,
	"./dogs/puppy_height/Cavalier King Charles Spaniel.jpg": 157,
	"./dogs/puppy_height/Central Asian Shepherd Dog": 158,
	"./dogs/puppy_height/Central Asian Shepherd Dog.jpg": 158,
	"./dogs/puppy_height/Chihuahua": 159,
	"./dogs/puppy_height/Chihuahua.jpg": 159,
	"./dogs/puppy_height/Chinese Crested Dog": 160,
	"./dogs/puppy_height/Chinese Crested Dog.jpg": 160,
	"./dogs/puppy_height/Chinese Shar-Pei": 161,
	"./dogs/puppy_height/Chinese Shar-Pei.jpg": 161,
	"./dogs/puppy_height/Chow Chow": 162,
	"./dogs/puppy_height/Chow Chow.jpg": 162,
	"./dogs/puppy_height/Coton de Tulear": 163,
	"./dogs/puppy_height/Coton de Tulear.jpg": 163,
	"./dogs/puppy_height/Czechoslovakian Wolfdog": 164,
	"./dogs/puppy_height/Czechoslovakian Wolfdog.jpg": 164,
	"./dogs/puppy_height/Dachshund": 165,
	"./dogs/puppy_height/Dachshund.jpg": 165,
	"./dogs/puppy_height/Dalmatian": 166,
	"./dogs/puppy_height/Dalmatian.jpg": 166,
	"./dogs/puppy_height/Dogue de Bordeaux": 167,
	"./dogs/puppy_height/Dogue de Bordeaux.jpg": 167,
	"./dogs/puppy_height/Dutch Shepherd Dog": 168,
	"./dogs/puppy_height/Dutch Shepherd Dog.jpg": 168,
	"./dogs/puppy_height/East-European Shepherd": 169,
	"./dogs/puppy_height/East-European Shepherd.jpg": 169,
	"./dogs/puppy_height/English Cocker Spaniel": 170,
	"./dogs/puppy_height/English Cocker Spaniel.jpg": 170,
	"./dogs/puppy_height/English Mastiff": 171,
	"./dogs/puppy_height/English Mastiff.jpg": 171,
	"./dogs/puppy_height/English Springer Spaniel": 172,
	"./dogs/puppy_height/English Springer Spaniel.jpg": 172,
	"./dogs/puppy_height/Eurasier": 173,
	"./dogs/puppy_height/Eurasier.jpg": 173,
	"./dogs/puppy_height/Finnish Lapphund": 174,
	"./dogs/puppy_height/Finnish Lapphund.jpg": 174,
	"./dogs/puppy_height/Fox Terrier (Smooth)": 175,
	"./dogs/puppy_height/Fox Terrier (Smooth).jpg": 175,
	"./dogs/puppy_height/German Pinscher": 176,
	"./dogs/puppy_height/German Pinscher.jpg": 176,
	"./dogs/puppy_height/German Shepherd Dog": 177,
	"./dogs/puppy_height/German Shepherd Dog.jpg": 177,
	"./dogs/puppy_height/German Shepherd Labrador Retriever Mix": 178,
	"./dogs/puppy_height/German Shepherd Labrador Retriever Mix.jpg": 178,
	"./dogs/puppy_height/German Shepherd Rottweiler Mix": 179,
	"./dogs/puppy_height/German Shepherd Rottweiler Mix.jpg": 179,
	"./dogs/puppy_height/German Shorthaired Pointer": 180,
	"./dogs/puppy_height/German Shorthaired Pointer.jpg": 180,
	"./dogs/puppy_height/Giant German Spitz": 181,
	"./dogs/puppy_height/Giant German Spitz.jpg": 181,
	"./dogs/puppy_height/Giant Schnauzer": 182,
	"./dogs/puppy_height/Giant Schnauzer.jpg": 182,
	"./dogs/puppy_height/Golden Retriever": 183,
	"./dogs/puppy_height/Golden Retriever.jpg": 183,
	"./dogs/puppy_height/Great Pyrenees": 184,
	"./dogs/puppy_height/Great Pyrenees.jpg": 184,
	"./dogs/puppy_height/Greater Swiss Mountain Dog": 185,
	"./dogs/puppy_height/Greater Swiss Mountain Dog.jpg": 185,
	"./dogs/puppy_height/Greenland Dog": 186,
	"./dogs/puppy_height/Greenland Dog.jpg": 186,
	"./dogs/puppy_height/Havanese": 187,
	"./dogs/puppy_height/Havanese.jpg": 187,
	"./dogs/puppy_height/Hokkaido": 188,
	"./dogs/puppy_height/Hokkaido.jpg": 188,
	"./dogs/puppy_height/Hovawart": 189,
	"./dogs/puppy_height/Hovawart.jpg": 189,
	"./dogs/puppy_height/Irish Setter": 190,
	"./dogs/puppy_height/Irish Setter.jpg": 190,
	"./dogs/puppy_height/Irish Terrier": 191,
	"./dogs/puppy_height/Irish Terrier.jpg": 191,
	"./dogs/puppy_height/Irish Wolfhound": 192,
	"./dogs/puppy_height/Irish Wolfhound.jpg": 192,
	"./dogs/puppy_height/Italian Greyhound": 193,
	"./dogs/puppy_height/Italian Greyhound.jpg": 193,
	"./dogs/puppy_height/Jack Russell Terrier": 194,
	"./dogs/puppy_height/Jack Russell Terrier.jpg": 194,
	"./dogs/puppy_height/Jagdterrier": 195,
	"./dogs/puppy_height/Jagdterrier.jpg": 195,
	"./dogs/puppy_height/Japanese Chin": 196,
	"./dogs/puppy_height/Japanese Chin.jpg": 196,
	"./dogs/puppy_height/Keeshond": 197,
	"./dogs/puppy_height/Keeshond.jpg": 197,
	"./dogs/puppy_height/Kooikerhondje": 198,
	"./dogs/puppy_height/Kooikerhondje.jpg": 198,
	"./dogs/puppy_height/Kyi-Leo": 199,
	"./dogs/puppy_height/Kyi-Leo.jpg": 199,
	"./dogs/puppy_height/Lagotto Romagnolo": 200,
	"./dogs/puppy_height/Lagotto Romagnolo.jpg": 200,
	"./dogs/puppy_height/Landseer": 201,
	"./dogs/puppy_height/Landseer.jpg": 201,
	"./dogs/puppy_height/Large Andalusian Hound": 202,
	"./dogs/puppy_height/Large Andalusian Hound.jpg": 202,
	"./dogs/puppy_height/Large Münsterländer": 203,
	"./dogs/puppy_height/Large Münsterländer.jpg": 203,
	"./dogs/puppy_height/Leonberger": 204,
	"./dogs/puppy_height/Leonberger.jpg": 204,
	"./dogs/puppy_height/Lhasa Apso": 205,
	"./dogs/puppy_height/Lhasa Apso.jpg": 205,
	"./dogs/puppy_height/Löwchen": 206,
	"./dogs/puppy_height/Löwchen.jpg": 206,
	"./dogs/puppy_height/Maltese": 207,
	"./dogs/puppy_height/Maltese Poodle Mix": 208,
	"./dogs/puppy_height/Maltese Poodle Mix.jpg": 208,
	"./dogs/puppy_height/Maltese.jpg": 207,
	"./dogs/puppy_height/Maremma Sheepdog": 209,
	"./dogs/puppy_height/Maremma Sheepdog.jpg": 209,
	"./dogs/puppy_height/Miniature Australian Shepherd": 210,
	"./dogs/puppy_height/Miniature Australian Shepherd.jpg": 210,
	"./dogs/puppy_height/Miniature Dachshund": 211,
	"./dogs/puppy_height/Miniature Dachshund.jpg": 211,
	"./dogs/puppy_height/Miniature Poodle": 212,
	"./dogs/puppy_height/Miniature Poodle.jpg": 212,
	"./dogs/puppy_height/Miniature Schnauzer": 213,
	"./dogs/puppy_height/Miniature Schnauzer.jpg": 213,
	"./dogs/puppy_height/Newfoundland": 214,
	"./dogs/puppy_height/Newfoundland.jpg": 214,
	"./dogs/puppy_height/Nova Scotia Duck Tolling Retriever": 215,
	"./dogs/puppy_height/Nova Scotia Duck Tolling Retriever.jpg": 215,
	"./dogs/puppy_height/Old English Sheepdog": 216,
	"./dogs/puppy_height/Old English Sheepdog.jpg": 216,
	"./dogs/puppy_height/Old German Shepherd Dog": 217,
	"./dogs/puppy_height/Old German Shepherd Dog.jpg": 217,
	"./dogs/puppy_height/Papillon": 218,
	"./dogs/puppy_height/Papillon.jpg": 218,
	"./dogs/puppy_height/Pekingese": 219,
	"./dogs/puppy_height/Pekingese.jpg": 219,
	"./dogs/puppy_height/Pembroke Welsh Corgi": 220,
	"./dogs/puppy_height/Pembroke Welsh Corgi.jpg": 220,
	"./dogs/puppy_height/Petit Basset Griffon Vendéen": 221,
	"./dogs/puppy_height/Petit Basset Griffon Vendéen.jpg": 221,
	"./dogs/puppy_height/Pocket Beagle": 222,
	"./dogs/puppy_height/Pocket Beagle.jpg": 222,
	"./dogs/puppy_height/Polish Lowland Sheepdog": 223,
	"./dogs/puppy_height/Polish Lowland Sheepdog.jpg": 223,
	"./dogs/puppy_height/Polish Tatra Sheepdog": 224,
	"./dogs/puppy_height/Polish Tatra Sheepdog.jpg": 224,
	"./dogs/puppy_height/Pomeranian": 225,
	"./dogs/puppy_height/Pomeranian.jpg": 225,
	"./dogs/puppy_height/Poodle": 226,
	"./dogs/puppy_height/Poodle.jpg": 226,
	"./dogs/puppy_height/Portuguese Water Dog": 227,
	"./dogs/puppy_height/Portuguese Water Dog.jpg": 227,
	"./dogs/puppy_height/Pug": 228,
	"./dogs/puppy_height/Pug.jpg": 228,
	"./dogs/puppy_height/Pyrenean Shepherd": 229,
	"./dogs/puppy_height/Pyrenean Shepherd.jpg": 229,
	"./dogs/puppy_height/Rhodesian Ridgeback": 230,
	"./dogs/puppy_height/Rhodesian Ridgeback.jpg": 230,
	"./dogs/puppy_height/Rottweiler": 231,
	"./dogs/puppy_height/Rottweiler.jpg": 231,
	"./dogs/puppy_height/Rough Collie": 232,
	"./dogs/puppy_height/Rough Collie.jpg": 232,
	"./dogs/puppy_height/Russkiy Toy": 233,
	"./dogs/puppy_height/Russkiy Toy.jpg": 233,
	"./dogs/puppy_height/Saint Bernard": 234,
	"./dogs/puppy_height/Saint Bernard.jpg": 234,
	"./dogs/puppy_height/Saluki": 235,
	"./dogs/puppy_height/Saluki.jpg": 235,
	"./dogs/puppy_height/Shetland Sheepdog": 236,
	"./dogs/puppy_height/Shetland Sheepdog.jpg": 236,
	"./dogs/puppy_height/Shih Tzu": 237,
	"./dogs/puppy_height/Shih Tzu.jpg": 237,
	"./dogs/puppy_height/Siberian Husky": 238,
	"./dogs/puppy_height/Siberian Husky.jpg": 238,
	"./dogs/puppy_height/Skye Terrier": 239,
	"./dogs/puppy_height/Skye Terrier.jpg": 239,
	"./dogs/puppy_height/Small Andalusian Hound": 240,
	"./dogs/puppy_height/Small Andalusian Hound.jpg": 240,
	"./dogs/puppy_height/Small Münsterländer": 241,
	"./dogs/puppy_height/Small Münsterländer.jpg": 241,
	"./dogs/puppy_height/Smooth Collie": 242,
	"./dogs/puppy_height/Smooth Collie.jpg": 242,
	"./dogs/puppy_height/Soft-Coated Wheaten Terrier": 243,
	"./dogs/puppy_height/Soft-Coated Wheaten Terrier.jpg": 243,
	"./dogs/puppy_height/Stabyhoun": 244,
	"./dogs/puppy_height/Stabyhoun.jpg": 244,
	"./dogs/puppy_height/Staffordshire Bull Terrier": 245,
	"./dogs/puppy_height/Staffordshire Bull Terrier.jpg": 245,
	"./dogs/puppy_height/Standard Schnauzer": 246,
	"./dogs/puppy_height/Standard Schnauzer.jpg": 246,
	"./dogs/puppy_height/Teacup Yorkshire Terrier": 247,
	"./dogs/puppy_height/Teacup Yorkshire Terrier.jpg": 247,
	"./dogs/puppy_height/Thai Ridgeback": 248,
	"./dogs/puppy_height/Thai Ridgeback.jpg": 248,
	"./dogs/puppy_height/Tibetan Mastiff": 249,
	"./dogs/puppy_height/Tibetan Mastiff.jpg": 249,
	"./dogs/puppy_height/Tibetan Spaniel": 250,
	"./dogs/puppy_height/Tibetan Spaniel.jpg": 250,
	"./dogs/puppy_height/Tibetan Terrier": 251,
	"./dogs/puppy_height/Tibetan Terrier.jpg": 251,
	"./dogs/puppy_height/Toy Fox Terrier": 252,
	"./dogs/puppy_height/Toy Fox Terrier.jpg": 252,
	"./dogs/puppy_height/Toy Poodle": 253,
	"./dogs/puppy_height/Toy Poodle.jpg": 253,
	"./dogs/puppy_height/Vizsla": 254,
	"./dogs/puppy_height/Vizsla.jpg": 254,
	"./dogs/puppy_height/Weimaraner": 255,
	"./dogs/puppy_height/Weimaraner.jpg": 255,
	"./dogs/puppy_height/Welsh Terrier": 256,
	"./dogs/puppy_height/Welsh Terrier.jpg": 256,
	"./dogs/puppy_height/West Highland White Terrier": 257,
	"./dogs/puppy_height/West Highland White Terrier.jpg": 257,
	"./dogs/puppy_height/Whippet": 258,
	"./dogs/puppy_height/Whippet.jpg": 258,
	"./dogs/puppy_height/Wire Fox Terrier": 259,
	"./dogs/puppy_height/Wire Fox Terrier.jpg": 259,
	"./dogs/puppy_height/Wirehaired Pointing Griffon": 260,
	"./dogs/puppy_height/Wirehaired Pointing Griffon.jpg": 260,
	"./dogs/puppy_height/Wirehaired Vizsla": 261,
	"./dogs/puppy_height/Wirehaired Vizsla.jpg": 261,
	"./dogs/puppy_height/Xoloitzcuintli": 262,
	"./dogs/puppy_height/Xoloitzcuintli.jpg": 262,
	"./dogs/puppy_height/Yorkshire Terrier": 263,
	"./dogs/puppy_height/Yorkshire Terrier.jpg": 263,
	"./dogs/puppy_height/Šarplaninac": 264,
	"./dogs/puppy_height/Šarplaninac.jpg": 264,
	"./dogs/puppy_height_cropped/Affenpinscher": 265,
	"./dogs/puppy_height_cropped/Affenpinscher.jpg": 265,
	"./dogs/puppy_height_cropped/Afghan Hound": 266,
	"./dogs/puppy_height_cropped/Afghan Hound.jpg": 266,
	"./dogs/puppy_height_cropped/Airedale Terrier": 267,
	"./dogs/puppy_height_cropped/Airedale Terrier.jpg": 267,
	"./dogs/puppy_height_cropped/Akita": 268,
	"./dogs/puppy_height_cropped/Akita.jpg": 268,
	"./dogs/puppy_height_cropped/Alano Español": 269,
	"./dogs/puppy_height_cropped/Alano Español.jpg": 269,
	"./dogs/puppy_height_cropped/Alaskan Malamute": 270,
	"./dogs/puppy_height_cropped/Alaskan Malamute.jpg": 270,
	"./dogs/puppy_height_cropped/Alpine Dachsbracke": 271,
	"./dogs/puppy_height_cropped/Alpine Dachsbracke.jpg": 271,
	"./dogs/puppy_height_cropped/American Akita": 272,
	"./dogs/puppy_height_cropped/American Akita.jpg": 272,
	"./dogs/puppy_height_cropped/American Bulldog": 273,
	"./dogs/puppy_height_cropped/American Bulldog.jpg": 273,
	"./dogs/puppy_height_cropped/American Bully": 274,
	"./dogs/puppy_height_cropped/American Bully.jpg": 274,
	"./dogs/puppy_height_cropped/American Cocker Spaniel": 275,
	"./dogs/puppy_height_cropped/American Cocker Spaniel.jpg": 275,
	"./dogs/puppy_height_cropped/American Hairless Terrier": 276,
	"./dogs/puppy_height_cropped/American Hairless Terrier.jpg": 276,
	"./dogs/puppy_height_cropped/American Pit Bull Terrier": 277,
	"./dogs/puppy_height_cropped/American Pit Bull Terrier.jpg": 277,
	"./dogs/puppy_height_cropped/American Staffordshire Terrier": 278,
	"./dogs/puppy_height_cropped/American Staffordshire Terrier.jpg": 278,
	"./dogs/puppy_height_cropped/Anatolian Shepherd Dog": 279,
	"./dogs/puppy_height_cropped/Anatolian Shepherd Dog.jpg": 279,
	"./dogs/puppy_height_cropped/Andalusian Hound (Medium)": 280,
	"./dogs/puppy_height_cropped/Andalusian Hound (Medium).jpg": 280,
	"./dogs/puppy_height_cropped/Appenzeller Sennenhund": 281,
	"./dogs/puppy_height_cropped/Appenzeller Sennenhund.jpg": 281,
	"./dogs/puppy_height_cropped/Australian Cattle Dog": 282,
	"./dogs/puppy_height_cropped/Australian Cattle Dog.jpg": 282,
	"./dogs/puppy_height_cropped/Australian Shepherd": 283,
	"./dogs/puppy_height_cropped/Australian Shepherd.jpg": 283,
	"./dogs/puppy_height_cropped/Australian Terrier": 284,
	"./dogs/puppy_height_cropped/Australian Terrier.jpg": 284,
	"./dogs/puppy_height_cropped/Barbado da Terceira": 285,
	"./dogs/puppy_height_cropped/Barbado da Terceira.jpg": 285,
	"./dogs/puppy_height_cropped/Barbet": 286,
	"./dogs/puppy_height_cropped/Barbet.jpg": 286,
	"./dogs/puppy_height_cropped/Basenji": 287,
	"./dogs/puppy_height_cropped/Basenji.jpg": 287,
	"./dogs/puppy_height_cropped/Basset Fauve de Bretagne": 288,
	"./dogs/puppy_height_cropped/Basset Fauve de Bretagne.jpg": 288,
	"./dogs/puppy_height_cropped/Basset Hound": 289,
	"./dogs/puppy_height_cropped/Basset Hound.jpg": 289,
	"./dogs/puppy_height_cropped/Beagle": 290,
	"./dogs/puppy_height_cropped/Beagle.jpg": 290,
	"./dogs/puppy_height_cropped/Bearded Collie": 291,
	"./dogs/puppy_height_cropped/Bearded Collie.jpg": 291,
	"./dogs/puppy_height_cropped/Beauceron": 292,
	"./dogs/puppy_height_cropped/Beauceron.jpg": 292,
	"./dogs/puppy_height_cropped/Bedlington Terrier": 293,
	"./dogs/puppy_height_cropped/Bedlington Terrier.jpg": 293,
	"./dogs/puppy_height_cropped/Belgian Shepherd Dog (Groenendael)": 294,
	"./dogs/puppy_height_cropped/Belgian Shepherd Dog (Groenendael).jpg": 294,
	"./dogs/puppy_height_cropped/Belgian Shepherd Dog (Laekenois)": 295,
	"./dogs/puppy_height_cropped/Belgian Shepherd Dog (Laekenois).jpg": 295,
	"./dogs/puppy_height_cropped/Belgian Shepherd Dog (Malinois)": 296,
	"./dogs/puppy_height_cropped/Belgian Shepherd Dog (Malinois).jpg": 296,
	"./dogs/puppy_height_cropped/Belgian Shepherd Dog (Tervuren)": 297,
	"./dogs/puppy_height_cropped/Belgian Shepherd Dog (Tervuren).jpg": 297,
	"./dogs/puppy_height_cropped/Berger Blanc Suisse": 298,
	"./dogs/puppy_height_cropped/Berger Blanc Suisse.jpg": 298,
	"./dogs/puppy_height_cropped/Berger Picard": 299,
	"./dogs/puppy_height_cropped/Berger Picard.jpg": 299,
	"./dogs/puppy_height_cropped/Bernese Mountain Dog": 300,
	"./dogs/puppy_height_cropped/Bernese Mountain Dog.jpg": 300,
	"./dogs/puppy_height_cropped/Bichon Frise": 301,
	"./dogs/puppy_height_cropped/Bichon Frise.jpg": 301,
	"./dogs/puppy_height_cropped/Biewer Terrier": 302,
	"./dogs/puppy_height_cropped/Biewer Terrier.jpg": 302,
	"./dogs/puppy_height_cropped/Boerboel": 303,
	"./dogs/puppy_height_cropped/Boerboel.jpg": 303,
	"./dogs/puppy_height_cropped/Bohemian Shepherd": 304,
	"./dogs/puppy_height_cropped/Bohemian Shepherd.jpg": 304,
	"./dogs/puppy_height_cropped/Bolognese": 305,
	"./dogs/puppy_height_cropped/Bolognese.jpg": 305,
	"./dogs/puppy_height_cropped/Bolonka Zwetna": 306,
	"./dogs/puppy_height_cropped/Bolonka Zwetna.jpg": 306,
	"./dogs/puppy_height_cropped/Border Collie": 307,
	"./dogs/puppy_height_cropped/Border Collie.jpg": 307,
	"./dogs/puppy_height_cropped/Border Terrier": 308,
	"./dogs/puppy_height_cropped/Border Terrier.jpg": 308,
	"./dogs/puppy_height_cropped/Borzoi": 309,
	"./dogs/puppy_height_cropped/Borzoi.jpg": 309,
	"./dogs/puppy_height_cropped/Boston Terrier": 310,
	"./dogs/puppy_height_cropped/Boston Terrier.jpg": 310,
	"./dogs/puppy_height_cropped/Bouvier des Ardennes": 311,
	"./dogs/puppy_height_cropped/Bouvier des Ardennes.jpg": 311,
	"./dogs/puppy_height_cropped/Bouvier des Flandres": 312,
	"./dogs/puppy_height_cropped/Bouvier des Flandres.jpg": 312,
	"./dogs/puppy_height_cropped/Boxer": 313,
	"./dogs/puppy_height_cropped/Boxer.jpg": 313,
	"./dogs/puppy_height_cropped/Braque Francais": 314,
	"./dogs/puppy_height_cropped/Braque Francais.jpg": 314,
	"./dogs/puppy_height_cropped/Brazilian Terrier": 315,
	"./dogs/puppy_height_cropped/Brazilian Terrier.jpg": 315,
	"./dogs/puppy_height_cropped/Briard": 316,
	"./dogs/puppy_height_cropped/Briard.jpg": 316,
	"./dogs/puppy_height_cropped/Brittany": 317,
	"./dogs/puppy_height_cropped/Brittany.jpg": 317,
	"./dogs/puppy_height_cropped/Brussels Griffon": 318,
	"./dogs/puppy_height_cropped/Brussels Griffon.jpg": 318,
	"./dogs/puppy_height_cropped/Bucovina Shepherd Dog": 319,
	"./dogs/puppy_height_cropped/Bucovina Shepherd Dog.jpg": 319,
	"./dogs/puppy_height_cropped/Bull Terrier": 320,
	"./dogs/puppy_height_cropped/Bull Terrier (Miniature)": 321,
	"./dogs/puppy_height_cropped/Bull Terrier (Miniature).jpg": 321,
	"./dogs/puppy_height_cropped/Bull Terrier.jpg": 320,
	"./dogs/puppy_height_cropped/Bulldog": 322,
	"./dogs/puppy_height_cropped/Bulldog.jpg": 322,
	"./dogs/puppy_height_cropped/Bullmastiff": 323,
	"./dogs/puppy_height_cropped/Bullmastiff.jpg": 323,
	"./dogs/puppy_height_cropped/Cairn Terrier": 324,
	"./dogs/puppy_height_cropped/Cairn Terrier.jpg": 324,
	"./dogs/puppy_height_cropped/Cane Corso": 325,
	"./dogs/puppy_height_cropped/Cane Corso.jpg": 325,
	"./dogs/puppy_height_cropped/Cardigan Welsh Corgi": 326,
	"./dogs/puppy_height_cropped/Cardigan Welsh Corgi.jpg": 326,
	"./dogs/puppy_height_cropped/Catahoula Leopard Dog": 327,
	"./dogs/puppy_height_cropped/Catahoula Leopard Dog.jpg": 327,
	"./dogs/puppy_height_cropped/Catalan Sheepdog": 328,
	"./dogs/puppy_height_cropped/Catalan Sheepdog.jpg": 328,
	"./dogs/puppy_height_cropped/Caucasian Shepherd Dog": 329,
	"./dogs/puppy_height_cropped/Caucasian Shepherd Dog.jpg": 329,
	"./dogs/puppy_height_cropped/Cavalier King Charles Spaniel": 330,
	"./dogs/puppy_height_cropped/Cavalier King Charles Spaniel.jpg": 330,
	"./dogs/puppy_height_cropped/Central Asian Shepherd Dog": 331,
	"./dogs/puppy_height_cropped/Central Asian Shepherd Dog.jpg": 331,
	"./dogs/puppy_height_cropped/Chihuahua": 332,
	"./dogs/puppy_height_cropped/Chihuahua.jpg": 332,
	"./dogs/puppy_height_cropped/Chinese Crested Dog": 333,
	"./dogs/puppy_height_cropped/Chinese Crested Dog.jpg": 333,
	"./dogs/puppy_height_cropped/Chinese Shar-Pei": 334,
	"./dogs/puppy_height_cropped/Chinese Shar-Pei.jpg": 334,
	"./dogs/puppy_height_cropped/Chow Chow": 335,
	"./dogs/puppy_height_cropped/Chow Chow.jpg": 335,
	"./dogs/puppy_height_cropped/Coton de Tulear": 336,
	"./dogs/puppy_height_cropped/Coton de Tulear.jpg": 336,
	"./dogs/puppy_height_cropped/Czechoslovakian Wolfdog": 337,
	"./dogs/puppy_height_cropped/Czechoslovakian Wolfdog.jpg": 337,
	"./dogs/puppy_height_cropped/Dachshund": 338,
	"./dogs/puppy_height_cropped/Dachshund.jpg": 338,
	"./dogs/puppy_height_cropped/Dalmatian": 339,
	"./dogs/puppy_height_cropped/Dalmatian.jpg": 339,
	"./dogs/puppy_height_cropped/Dogue de Bordeaux": 340,
	"./dogs/puppy_height_cropped/Dogue de Bordeaux.jpg": 340,
	"./dogs/puppy_height_cropped/Dutch Shepherd Dog": 341,
	"./dogs/puppy_height_cropped/Dutch Shepherd Dog.jpg": 341,
	"./dogs/puppy_height_cropped/East-European Shepherd": 342,
	"./dogs/puppy_height_cropped/East-European Shepherd.jpg": 342,
	"./dogs/puppy_height_cropped/English Cocker Spaniel": 343,
	"./dogs/puppy_height_cropped/English Cocker Spaniel.jpg": 343,
	"./dogs/puppy_height_cropped/English Mastiff": 344,
	"./dogs/puppy_height_cropped/English Mastiff.jpg": 344,
	"./dogs/puppy_height_cropped/English Springer Spaniel": 345,
	"./dogs/puppy_height_cropped/English Springer Spaniel.jpg": 345,
	"./dogs/puppy_height_cropped/Eurasier": 346,
	"./dogs/puppy_height_cropped/Eurasier.jpg": 346,
	"./dogs/puppy_height_cropped/Finnish Lapphund": 347,
	"./dogs/puppy_height_cropped/Finnish Lapphund.jpg": 347,
	"./dogs/puppy_height_cropped/Fox Terrier (Smooth)": 348,
	"./dogs/puppy_height_cropped/Fox Terrier (Smooth).jpg": 348,
	"./dogs/puppy_height_cropped/German Pinscher": 349,
	"./dogs/puppy_height_cropped/German Pinscher.jpg": 349,
	"./dogs/puppy_height_cropped/German Shepherd Dog": 350,
	"./dogs/puppy_height_cropped/German Shepherd Dog.jpg": 350,
	"./dogs/puppy_height_cropped/German Shepherd Labrador Retriever Mix": 351,
	"./dogs/puppy_height_cropped/German Shepherd Labrador Retriever Mix.jpg": 351,
	"./dogs/puppy_height_cropped/German Shepherd Rottweiler Mix": 352,
	"./dogs/puppy_height_cropped/German Shepherd Rottweiler Mix.jpg": 352,
	"./dogs/puppy_height_cropped/German Shorthaired Pointer": 353,
	"./dogs/puppy_height_cropped/German Shorthaired Pointer.jpg": 353,
	"./dogs/puppy_height_cropped/Giant German Spitz": 354,
	"./dogs/puppy_height_cropped/Giant German Spitz.jpg": 354,
	"./dogs/puppy_height_cropped/Giant Schnauzer": 355,
	"./dogs/puppy_height_cropped/Giant Schnauzer.jpg": 355,
	"./dogs/puppy_height_cropped/Golden Retriever": 356,
	"./dogs/puppy_height_cropped/Golden Retriever.jpg": 356,
	"./dogs/puppy_height_cropped/Great Pyrenees": 357,
	"./dogs/puppy_height_cropped/Great Pyrenees.jpg": 357,
	"./dogs/puppy_height_cropped/Greater Swiss Mountain Dog": 358,
	"./dogs/puppy_height_cropped/Greater Swiss Mountain Dog.jpg": 358,
	"./dogs/puppy_height_cropped/Greenland Dog": 359,
	"./dogs/puppy_height_cropped/Greenland Dog.jpg": 359,
	"./dogs/puppy_height_cropped/Havanese": 360,
	"./dogs/puppy_height_cropped/Havanese.jpg": 360,
	"./dogs/puppy_height_cropped/Hokkaido": 361,
	"./dogs/puppy_height_cropped/Hokkaido.jpg": 361,
	"./dogs/puppy_height_cropped/Hovawart": 362,
	"./dogs/puppy_height_cropped/Hovawart.jpg": 362,
	"./dogs/puppy_height_cropped/Irish Setter": 363,
	"./dogs/puppy_height_cropped/Irish Setter.jpg": 363,
	"./dogs/puppy_height_cropped/Irish Terrier": 364,
	"./dogs/puppy_height_cropped/Irish Terrier.jpg": 364,
	"./dogs/puppy_height_cropped/Irish Wolfhound": 365,
	"./dogs/puppy_height_cropped/Irish Wolfhound.jpg": 365,
	"./dogs/puppy_height_cropped/Italian Greyhound": 366,
	"./dogs/puppy_height_cropped/Italian Greyhound.jpg": 366,
	"./dogs/puppy_height_cropped/Jack Russell Terrier": 367,
	"./dogs/puppy_height_cropped/Jack Russell Terrier.jpg": 367,
	"./dogs/puppy_height_cropped/Jagdterrier": 368,
	"./dogs/puppy_height_cropped/Jagdterrier.jpg": 368,
	"./dogs/puppy_height_cropped/Japanese Chin": 369,
	"./dogs/puppy_height_cropped/Japanese Chin.jpg": 369,
	"./dogs/puppy_height_cropped/Keeshond": 370,
	"./dogs/puppy_height_cropped/Keeshond.jpg": 370,
	"./dogs/puppy_height_cropped/Kooikerhondje": 371,
	"./dogs/puppy_height_cropped/Kooikerhondje.jpg": 371,
	"./dogs/puppy_height_cropped/Kyi-Leo": 372,
	"./dogs/puppy_height_cropped/Kyi-Leo.jpg": 372,
	"./dogs/puppy_height_cropped/Lagotto Romagnolo": 373,
	"./dogs/puppy_height_cropped/Lagotto Romagnolo.jpg": 373,
	"./dogs/puppy_height_cropped/Landseer": 374,
	"./dogs/puppy_height_cropped/Landseer.jpg": 374,
	"./dogs/puppy_height_cropped/Large Andalusian Hound": 375,
	"./dogs/puppy_height_cropped/Large Andalusian Hound.jpg": 375,
	"./dogs/puppy_height_cropped/Large Münsterländer": 376,
	"./dogs/puppy_height_cropped/Large Münsterländer.jpg": 376,
	"./dogs/puppy_height_cropped/Leonberger": 377,
	"./dogs/puppy_height_cropped/Leonberger.jpg": 377,
	"./dogs/puppy_height_cropped/Lhasa Apso": 378,
	"./dogs/puppy_height_cropped/Lhasa Apso.jpg": 378,
	"./dogs/puppy_height_cropped/Löwchen": 379,
	"./dogs/puppy_height_cropped/Löwchen.jpg": 379,
	"./dogs/puppy_height_cropped/Maltese": 380,
	"./dogs/puppy_height_cropped/Maltese Poodle Mix": 381,
	"./dogs/puppy_height_cropped/Maltese Poodle Mix.jpg": 381,
	"./dogs/puppy_height_cropped/Maltese.jpg": 380,
	"./dogs/puppy_height_cropped/Maremma Sheepdog": 382,
	"./dogs/puppy_height_cropped/Maremma Sheepdog.jpg": 382,
	"./dogs/puppy_height_cropped/Miniature Australian Shepherd": 383,
	"./dogs/puppy_height_cropped/Miniature Australian Shepherd.jpg": 383,
	"./dogs/puppy_height_cropped/Miniature Dachshund": 384,
	"./dogs/puppy_height_cropped/Miniature Dachshund.jpg": 384,
	"./dogs/puppy_height_cropped/Miniature Poodle": 385,
	"./dogs/puppy_height_cropped/Miniature Poodle.jpg": 385,
	"./dogs/puppy_height_cropped/Miniature Schnauzer": 386,
	"./dogs/puppy_height_cropped/Miniature Schnauzer.jpg": 386,
	"./dogs/puppy_height_cropped/Newfoundland": 387,
	"./dogs/puppy_height_cropped/Newfoundland.jpg": 387,
	"./dogs/puppy_height_cropped/Nova Scotia Duck Tolling Retriever": 388,
	"./dogs/puppy_height_cropped/Nova Scotia Duck Tolling Retriever.jpg": 388,
	"./dogs/puppy_height_cropped/Old English Sheepdog": 389,
	"./dogs/puppy_height_cropped/Old English Sheepdog.jpg": 389,
	"./dogs/puppy_height_cropped/Old German Shepherd Dog": 390,
	"./dogs/puppy_height_cropped/Old German Shepherd Dog.jpg": 390,
	"./dogs/puppy_height_cropped/Papillon": 391,
	"./dogs/puppy_height_cropped/Papillon.jpg": 391,
	"./dogs/puppy_height_cropped/Pekingese": 392,
	"./dogs/puppy_height_cropped/Pekingese.jpg": 392,
	"./dogs/puppy_height_cropped/Pembroke Welsh Corgi": 393,
	"./dogs/puppy_height_cropped/Pembroke Welsh Corgi.jpg": 393,
	"./dogs/puppy_height_cropped/Petit Basset Griffon Vendéen": 394,
	"./dogs/puppy_height_cropped/Petit Basset Griffon Vendéen.jpg": 394,
	"./dogs/puppy_height_cropped/Pocket Beagle": 395,
	"./dogs/puppy_height_cropped/Pocket Beagle.jpg": 395,
	"./dogs/puppy_height_cropped/Polish Lowland Sheepdog": 396,
	"./dogs/puppy_height_cropped/Polish Lowland Sheepdog.jpg": 396,
	"./dogs/puppy_height_cropped/Polish Tatra Sheepdog": 397,
	"./dogs/puppy_height_cropped/Polish Tatra Sheepdog.jpg": 397,
	"./dogs/puppy_height_cropped/Pomeranian": 398,
	"./dogs/puppy_height_cropped/Pomeranian.jpg": 398,
	"./dogs/puppy_height_cropped/Poodle": 399,
	"./dogs/puppy_height_cropped/Poodle.jpg": 399,
	"./dogs/puppy_height_cropped/Portuguese Water Dog": 400,
	"./dogs/puppy_height_cropped/Portuguese Water Dog.jpg": 400,
	"./dogs/puppy_height_cropped/Pug": 401,
	"./dogs/puppy_height_cropped/Pug.jpg": 401,
	"./dogs/puppy_height_cropped/Pyrenean Shepherd": 402,
	"./dogs/puppy_height_cropped/Pyrenean Shepherd.jpg": 402,
	"./dogs/puppy_height_cropped/Rhodesian Ridgeback": 403,
	"./dogs/puppy_height_cropped/Rhodesian Ridgeback.jpg": 403,
	"./dogs/puppy_height_cropped/Rottweiler": 404,
	"./dogs/puppy_height_cropped/Rottweiler.jpg": 404,
	"./dogs/puppy_height_cropped/Rough Collie": 405,
	"./dogs/puppy_height_cropped/Rough Collie.jpg": 405,
	"./dogs/puppy_height_cropped/Russkiy Toy": 406,
	"./dogs/puppy_height_cropped/Russkiy Toy.jpg": 406,
	"./dogs/puppy_height_cropped/Saint Bernard": 407,
	"./dogs/puppy_height_cropped/Saint Bernard.jpg": 407,
	"./dogs/puppy_height_cropped/Saluki": 408,
	"./dogs/puppy_height_cropped/Saluki.jpg": 408,
	"./dogs/puppy_height_cropped/Shetland Sheepdog": 409,
	"./dogs/puppy_height_cropped/Shetland Sheepdog.jpg": 409,
	"./dogs/puppy_height_cropped/Shih Tzu": 410,
	"./dogs/puppy_height_cropped/Shih Tzu.jpg": 410,
	"./dogs/puppy_height_cropped/Siberian Husky": 411,
	"./dogs/puppy_height_cropped/Siberian Husky.jpg": 411,
	"./dogs/puppy_height_cropped/Skye Terrier": 412,
	"./dogs/puppy_height_cropped/Skye Terrier.jpg": 412,
	"./dogs/puppy_height_cropped/Small Andalusian Hound": 413,
	"./dogs/puppy_height_cropped/Small Andalusian Hound.jpg": 413,
	"./dogs/puppy_height_cropped/Small Münsterländer": 414,
	"./dogs/puppy_height_cropped/Small Münsterländer.jpg": 414,
	"./dogs/puppy_height_cropped/Smooth Collie": 415,
	"./dogs/puppy_height_cropped/Smooth Collie.jpg": 415,
	"./dogs/puppy_height_cropped/Soft-Coated Wheaten Terrier": 416,
	"./dogs/puppy_height_cropped/Soft-Coated Wheaten Terrier.jpg": 416,
	"./dogs/puppy_height_cropped/Stabyhoun": 417,
	"./dogs/puppy_height_cropped/Stabyhoun.jpg": 417,
	"./dogs/puppy_height_cropped/Staffordshire Bull Terrier": 418,
	"./dogs/puppy_height_cropped/Staffordshire Bull Terrier.jpg": 418,
	"./dogs/puppy_height_cropped/Standard Schnauzer": 419,
	"./dogs/puppy_height_cropped/Standard Schnauzer.jpg": 419,
	"./dogs/puppy_height_cropped/Teacup Yorkshire Terrier": 420,
	"./dogs/puppy_height_cropped/Teacup Yorkshire Terrier.jpg": 420,
	"./dogs/puppy_height_cropped/Thai Ridgeback": 421,
	"./dogs/puppy_height_cropped/Thai Ridgeback.jpg": 421,
	"./dogs/puppy_height_cropped/Tibetan Mastiff": 422,
	"./dogs/puppy_height_cropped/Tibetan Mastiff.jpg": 422,
	"./dogs/puppy_height_cropped/Tibetan Spaniel": 423,
	"./dogs/puppy_height_cropped/Tibetan Spaniel.jpg": 423,
	"./dogs/puppy_height_cropped/Tibetan Terrier": 424,
	"./dogs/puppy_height_cropped/Tibetan Terrier.jpg": 424,
	"./dogs/puppy_height_cropped/Toy Fox Terrier": 425,
	"./dogs/puppy_height_cropped/Toy Fox Terrier.jpg": 425,
	"./dogs/puppy_height_cropped/Toy Poodle": 426,
	"./dogs/puppy_height_cropped/Toy Poodle.jpg": 426,
	"./dogs/puppy_height_cropped/Vizsla": 427,
	"./dogs/puppy_height_cropped/Vizsla.jpg": 427,
	"./dogs/puppy_height_cropped/Weimaraner": 428,
	"./dogs/puppy_height_cropped/Weimaraner.jpg": 428,
	"./dogs/puppy_height_cropped/Welsh Terrier": 429,
	"./dogs/puppy_height_cropped/Welsh Terrier.jpg": 429,
	"./dogs/puppy_height_cropped/West Highland White Terrier": 430,
	"./dogs/puppy_height_cropped/West Highland White Terrier.jpg": 430,
	"./dogs/puppy_height_cropped/Whippet": 431,
	"./dogs/puppy_height_cropped/Whippet.jpg": 431,
	"./dogs/puppy_height_cropped/Wire Fox Terrier": 432,
	"./dogs/puppy_height_cropped/Wire Fox Terrier.jpg": 432,
	"./dogs/puppy_height_cropped/Wirehaired Pointing Griffon": 433,
	"./dogs/puppy_height_cropped/Wirehaired Pointing Griffon.jpg": 433,
	"./dogs/puppy_height_cropped/Wirehaired Vizsla": 434,
	"./dogs/puppy_height_cropped/Wirehaired Vizsla.jpg": 434,
	"./dogs/puppy_height_cropped/Xoloitzcuintli": 435,
	"./dogs/puppy_height_cropped/Xoloitzcuintli.jpg": 435,
	"./dogs/puppy_height_cropped/Yorkshire Terrier": 436,
	"./dogs/puppy_height_cropped/Yorkshire Terrier.jpg": 436,
	"./dogs/puppy_height_cropped/Šarplaninac": 437,
	"./dogs/puppy_height_cropped/Šarplaninac.jpg": 437,
	"./dogs/puppy_weight/Affenpinscher": 438,
	"./dogs/puppy_weight/Affenpinscher.jpg": 438,
	"./dogs/puppy_weight/Afghan Hound": 439,
	"./dogs/puppy_weight/Afghan Hound.jpg": 439,
	"./dogs/puppy_weight/Airedale Terrier": 440,
	"./dogs/puppy_weight/Airedale Terrier.jpg": 440,
	"./dogs/puppy_weight/Akita": 441,
	"./dogs/puppy_weight/Akita.jpg": 441,
	"./dogs/puppy_weight/Alano Español": 442,
	"./dogs/puppy_weight/Alano Español.jpg": 442,
	"./dogs/puppy_weight/Alaskan Malamute": 443,
	"./dogs/puppy_weight/Alaskan Malamute.jpg": 443,
	"./dogs/puppy_weight/Alpine Dachsbracke": 444,
	"./dogs/puppy_weight/Alpine Dachsbracke.jpg": 444,
	"./dogs/puppy_weight/American Akita": 445,
	"./dogs/puppy_weight/American Akita.jpg": 445,
	"./dogs/puppy_weight/American Bulldog": 446,
	"./dogs/puppy_weight/American Bulldog.jpg": 446,
	"./dogs/puppy_weight/American Bully": 447,
	"./dogs/puppy_weight/American Bully.jpg": 447,
	"./dogs/puppy_weight/American Cocker Spaniel": 448,
	"./dogs/puppy_weight/American Cocker Spaniel.jpg": 448,
	"./dogs/puppy_weight/American Hairless Terrier": 449,
	"./dogs/puppy_weight/American Hairless Terrier.jpg": 449,
	"./dogs/puppy_weight/American Pit Bull Terrier": 450,
	"./dogs/puppy_weight/American Pit Bull Terrier.jpg": 450,
	"./dogs/puppy_weight/American Staffordshire Terrier": 451,
	"./dogs/puppy_weight/American Staffordshire Terrier.jpg": 451,
	"./dogs/puppy_weight/Anatolian Shepherd Dog": 452,
	"./dogs/puppy_weight/Anatolian Shepherd Dog.jpg": 452,
	"./dogs/puppy_weight/Andalusian Hound (Medium)": 453,
	"./dogs/puppy_weight/Andalusian Hound (Medium).jpg": 453,
	"./dogs/puppy_weight/Appenzeller Sennenhund": 454,
	"./dogs/puppy_weight/Appenzeller Sennenhund.jpg": 454,
	"./dogs/puppy_weight/Australian Cattle Dog": 455,
	"./dogs/puppy_weight/Australian Cattle Dog.jpg": 455,
	"./dogs/puppy_weight/Australian Shepherd": 456,
	"./dogs/puppy_weight/Australian Shepherd.jpg": 456,
	"./dogs/puppy_weight/Australian Terrier": 457,
	"./dogs/puppy_weight/Australian Terrier.jpg": 457,
	"./dogs/puppy_weight/Barbado da Terceira": 458,
	"./dogs/puppy_weight/Barbado da Terceira.jpg": 458,
	"./dogs/puppy_weight/Barbet": 459,
	"./dogs/puppy_weight/Barbet.jpg": 459,
	"./dogs/puppy_weight/Basenji": 460,
	"./dogs/puppy_weight/Basenji.jpg": 460,
	"./dogs/puppy_weight/Basset Fauve de Bretagne": 461,
	"./dogs/puppy_weight/Basset Fauve de Bretagne.jpg": 461,
	"./dogs/puppy_weight/Basset Hound": 462,
	"./dogs/puppy_weight/Basset Hound.jpg": 462,
	"./dogs/puppy_weight/Beagle": 463,
	"./dogs/puppy_weight/Beagle.jpg": 463,
	"./dogs/puppy_weight/Bearded Collie": 464,
	"./dogs/puppy_weight/Bearded Collie.jpg": 464,
	"./dogs/puppy_weight/Beauceron": 465,
	"./dogs/puppy_weight/Beauceron.jpg": 465,
	"./dogs/puppy_weight/Bedlington Terrier": 466,
	"./dogs/puppy_weight/Bedlington Terrier.jpg": 466,
	"./dogs/puppy_weight/Belgian Shepherd Dog (Groenendael)": 467,
	"./dogs/puppy_weight/Belgian Shepherd Dog (Groenendael).jpg": 467,
	"./dogs/puppy_weight/Belgian Shepherd Dog (Laekenois)": 468,
	"./dogs/puppy_weight/Belgian Shepherd Dog (Laekenois).jpg": 468,
	"./dogs/puppy_weight/Belgian Shepherd Dog (Malinois)": 469,
	"./dogs/puppy_weight/Belgian Shepherd Dog (Malinois).jpg": 469,
	"./dogs/puppy_weight/Belgian Shepherd Dog (Tervuren)": 470,
	"./dogs/puppy_weight/Belgian Shepherd Dog (Tervuren).jpg": 470,
	"./dogs/puppy_weight/Berger Blanc Suisse": 471,
	"./dogs/puppy_weight/Berger Blanc Suisse.jpg": 471,
	"./dogs/puppy_weight/Berger Picard": 472,
	"./dogs/puppy_weight/Berger Picard.jpg": 472,
	"./dogs/puppy_weight/Bernese Mountain Dog": 473,
	"./dogs/puppy_weight/Bernese Mountain Dog.jpg": 473,
	"./dogs/puppy_weight/Bichon Frise": 474,
	"./dogs/puppy_weight/Bichon Frise.jpg": 474,
	"./dogs/puppy_weight/Biewer Terrier": 475,
	"./dogs/puppy_weight/Biewer Terrier.jpg": 475,
	"./dogs/puppy_weight/Boerboel": 476,
	"./dogs/puppy_weight/Boerboel.jpg": 476,
	"./dogs/puppy_weight/Bohemian Shepherd": 477,
	"./dogs/puppy_weight/Bohemian Shepherd.jpg": 477,
	"./dogs/puppy_weight/Bolognese": 478,
	"./dogs/puppy_weight/Bolognese.jpg": 478,
	"./dogs/puppy_weight/Bolonka Zwetna": 479,
	"./dogs/puppy_weight/Bolonka Zwetna.jpg": 479,
	"./dogs/puppy_weight/Border Collie": 480,
	"./dogs/puppy_weight/Border Collie.jpg": 480,
	"./dogs/puppy_weight/Border Terrier": 481,
	"./dogs/puppy_weight/Border Terrier.jpg": 481,
	"./dogs/puppy_weight/Borzoi": 482,
	"./dogs/puppy_weight/Borzoi.jpg": 482,
	"./dogs/puppy_weight/Boston Terrier": 483,
	"./dogs/puppy_weight/Boston Terrier.jpg": 483,
	"./dogs/puppy_weight/Bouvier des Ardennes": 484,
	"./dogs/puppy_weight/Bouvier des Ardennes.jpg": 484,
	"./dogs/puppy_weight/Bouvier des Flandres": 485,
	"./dogs/puppy_weight/Bouvier des Flandres.jpg": 485,
	"./dogs/puppy_weight/Boxer": 486,
	"./dogs/puppy_weight/Boxer.jpg": 486,
	"./dogs/puppy_weight/Braque Francais": 487,
	"./dogs/puppy_weight/Braque Francais.jpg": 487,
	"./dogs/puppy_weight/Brazilian Terrier": 488,
	"./dogs/puppy_weight/Brazilian Terrier.jpg": 488,
	"./dogs/puppy_weight/Briard": 489,
	"./dogs/puppy_weight/Briard.jpg": 489,
	"./dogs/puppy_weight/Brittany": 490,
	"./dogs/puppy_weight/Brittany.jpg": 490,
	"./dogs/puppy_weight/Brussels Griffon": 491,
	"./dogs/puppy_weight/Brussels Griffon.jpg": 491,
	"./dogs/puppy_weight/Bucovina Shepherd Dog": 492,
	"./dogs/puppy_weight/Bucovina Shepherd Dog.jpg": 492,
	"./dogs/puppy_weight/Bull Terrier": 493,
	"./dogs/puppy_weight/Bull Terrier (Miniature)": 494,
	"./dogs/puppy_weight/Bull Terrier (Miniature).jpg": 494,
	"./dogs/puppy_weight/Bull Terrier.jpg": 493,
	"./dogs/puppy_weight/Bulldog": 495,
	"./dogs/puppy_weight/Bulldog.jpg": 495,
	"./dogs/puppy_weight/Bullmastiff": 496,
	"./dogs/puppy_weight/Bullmastiff.jpg": 496,
	"./dogs/puppy_weight/Cairn Terrier": 497,
	"./dogs/puppy_weight/Cairn Terrier.jpg": 497,
	"./dogs/puppy_weight/Cane Corso": 498,
	"./dogs/puppy_weight/Cane Corso.jpg": 498,
	"./dogs/puppy_weight/Cardigan Welsh Corgi": 499,
	"./dogs/puppy_weight/Cardigan Welsh Corgi.jpg": 499,
	"./dogs/puppy_weight/Catahoula Leopard Dog": 500,
	"./dogs/puppy_weight/Catahoula Leopard Dog.jpg": 500,
	"./dogs/puppy_weight/Catalan Sheepdog": 501,
	"./dogs/puppy_weight/Catalan Sheepdog.jpg": 501,
	"./dogs/puppy_weight/Caucasian Shepherd Dog": 502,
	"./dogs/puppy_weight/Caucasian Shepherd Dog.jpg": 502,
	"./dogs/puppy_weight/Cavalier King Charles Spaniel": 503,
	"./dogs/puppy_weight/Cavalier King Charles Spaniel.jpg": 503,
	"./dogs/puppy_weight/Central Asian Shepherd Dog": 504,
	"./dogs/puppy_weight/Central Asian Shepherd Dog.jpg": 504,
	"./dogs/puppy_weight/Chihuahua": 505,
	"./dogs/puppy_weight/Chihuahua.jpg": 505,
	"./dogs/puppy_weight/Chinese Crested Dog": 506,
	"./dogs/puppy_weight/Chinese Crested Dog.jpg": 506,
	"./dogs/puppy_weight/Chinese Shar-Pei": 507,
	"./dogs/puppy_weight/Chinese Shar-Pei.jpg": 507,
	"./dogs/puppy_weight/Chow Chow": 508,
	"./dogs/puppy_weight/Chow Chow.jpg": 508,
	"./dogs/puppy_weight/Coton de Tulear": 509,
	"./dogs/puppy_weight/Coton de Tulear.jpg": 509,
	"./dogs/puppy_weight/Czechoslovakian Wolfdog": 510,
	"./dogs/puppy_weight/Czechoslovakian Wolfdog.jpg": 510,
	"./dogs/puppy_weight/Dachshund": 511,
	"./dogs/puppy_weight/Dachshund.jpg": 511,
	"./dogs/puppy_weight/Dalmatian": 512,
	"./dogs/puppy_weight/Dalmatian.jpg": 512,
	"./dogs/puppy_weight/Dogue de Bordeaux": 513,
	"./dogs/puppy_weight/Dogue de Bordeaux.jpg": 513,
	"./dogs/puppy_weight/Dutch Shepherd Dog": 514,
	"./dogs/puppy_weight/Dutch Shepherd Dog.jpg": 514,
	"./dogs/puppy_weight/East-European Shepherd": 515,
	"./dogs/puppy_weight/East-European Shepherd.jpg": 515,
	"./dogs/puppy_weight/English Cocker Spaniel": 516,
	"./dogs/puppy_weight/English Cocker Spaniel.jpg": 516,
	"./dogs/puppy_weight/English Mastiff": 517,
	"./dogs/puppy_weight/English Mastiff.jpg": 517,
	"./dogs/puppy_weight/English Springer Spaniel": 518,
	"./dogs/puppy_weight/English Springer Spaniel.jpg": 518,
	"./dogs/puppy_weight/Eurasier": 519,
	"./dogs/puppy_weight/Eurasier.jpg": 519,
	"./dogs/puppy_weight/Finnish Lapphund": 520,
	"./dogs/puppy_weight/Finnish Lapphund.jpg": 520,
	"./dogs/puppy_weight/Fox Terrier (Smooth)": 521,
	"./dogs/puppy_weight/Fox Terrier (Smooth).jpg": 521,
	"./dogs/puppy_weight/German Pinscher": 522,
	"./dogs/puppy_weight/German Pinscher.jpg": 522,
	"./dogs/puppy_weight/German Shepherd Dog": 523,
	"./dogs/puppy_weight/German Shepherd Dog.jpg": 523,
	"./dogs/puppy_weight/German Shepherd Labrador Retriever Mix": 524,
	"./dogs/puppy_weight/German Shepherd Labrador Retriever Mix.jpg": 524,
	"./dogs/puppy_weight/German Shepherd Rottweiler Mix": 525,
	"./dogs/puppy_weight/German Shepherd Rottweiler Mix.jpg": 525,
	"./dogs/puppy_weight/German Shorthaired Pointer": 526,
	"./dogs/puppy_weight/German Shorthaired Pointer.jpg": 526,
	"./dogs/puppy_weight/Giant German Spitz": 527,
	"./dogs/puppy_weight/Giant German Spitz.jpg": 527,
	"./dogs/puppy_weight/Giant Schnauzer": 528,
	"./dogs/puppy_weight/Giant Schnauzer.jpg": 528,
	"./dogs/puppy_weight/Golden Retriever": 529,
	"./dogs/puppy_weight/Golden Retriever.jpg": 529,
	"./dogs/puppy_weight/Great Pyrenees": 530,
	"./dogs/puppy_weight/Great Pyrenees.jpg": 530,
	"./dogs/puppy_weight/Greater Swiss Mountain Dog": 531,
	"./dogs/puppy_weight/Greater Swiss Mountain Dog.jpg": 531,
	"./dogs/puppy_weight/Greenland Dog": 532,
	"./dogs/puppy_weight/Greenland Dog.jpg": 532,
	"./dogs/puppy_weight/Havanese": 533,
	"./dogs/puppy_weight/Havanese.jpg": 533,
	"./dogs/puppy_weight/Hokkaido": 534,
	"./dogs/puppy_weight/Hokkaido.jpg": 534,
	"./dogs/puppy_weight/Hovawart": 535,
	"./dogs/puppy_weight/Hovawart.jpg": 535,
	"./dogs/puppy_weight/Irish Setter": 536,
	"./dogs/puppy_weight/Irish Setter.jpg": 536,
	"./dogs/puppy_weight/Irish Terrier": 537,
	"./dogs/puppy_weight/Irish Terrier.jpg": 537,
	"./dogs/puppy_weight/Irish Wolfhound": 538,
	"./dogs/puppy_weight/Irish Wolfhound.jpg": 538,
	"./dogs/puppy_weight/Italian Greyhound": 539,
	"./dogs/puppy_weight/Italian Greyhound.jpg": 539,
	"./dogs/puppy_weight/Jack Russell Terrier": 540,
	"./dogs/puppy_weight/Jack Russell Terrier.jpg": 540,
	"./dogs/puppy_weight/Jagdterrier": 541,
	"./dogs/puppy_weight/Jagdterrier.jpg": 541,
	"./dogs/puppy_weight/Japanese Chin": 542,
	"./dogs/puppy_weight/Japanese Chin.jpg": 542,
	"./dogs/puppy_weight/Keeshond": 543,
	"./dogs/puppy_weight/Keeshond.jpg": 543,
	"./dogs/puppy_weight/Kooikerhondje": 544,
	"./dogs/puppy_weight/Kooikerhondje.jpg": 544,
	"./dogs/puppy_weight/Kyi-Leo": 545,
	"./dogs/puppy_weight/Kyi-Leo.jpg": 545,
	"./dogs/puppy_weight/Labrador Retriever": 546,
	"./dogs/puppy_weight/Labrador Retriever.jpg": 546,
	"./dogs/puppy_weight/Lagotto Romagnolo": 547,
	"./dogs/puppy_weight/Lagotto Romagnolo.jpg": 547,
	"./dogs/puppy_weight/Landseer": 548,
	"./dogs/puppy_weight/Landseer.jpg": 548,
	"./dogs/puppy_weight/Large Andalusian Hound": 549,
	"./dogs/puppy_weight/Large Andalusian Hound.jpg": 549,
	"./dogs/puppy_weight/Large Münsterländer": 550,
	"./dogs/puppy_weight/Large Münsterländer.jpg": 550,
	"./dogs/puppy_weight/Leonberger": 551,
	"./dogs/puppy_weight/Leonberger.jpg": 551,
	"./dogs/puppy_weight/Lhasa Apso": 552,
	"./dogs/puppy_weight/Lhasa Apso.jpg": 552,
	"./dogs/puppy_weight/Löwchen": 553,
	"./dogs/puppy_weight/Löwchen.jpg": 553,
	"./dogs/puppy_weight/Maltese": 554,
	"./dogs/puppy_weight/Maltese Poodle Mix": 555,
	"./dogs/puppy_weight/Maltese Poodle Mix.jpg": 555,
	"./dogs/puppy_weight/Maltese.jpg": 554,
	"./dogs/puppy_weight/Maremma Sheepdog": 556,
	"./dogs/puppy_weight/Maremma Sheepdog.jpg": 556,
	"./dogs/puppy_weight/Miniature Australian Shepherd": 557,
	"./dogs/puppy_weight/Miniature Australian Shepherd.jpg": 557,
	"./dogs/puppy_weight/Miniature Dachshund": 558,
	"./dogs/puppy_weight/Miniature Dachshund.jpg": 558,
	"./dogs/puppy_weight/Miniature Poodle": 559,
	"./dogs/puppy_weight/Miniature Poodle.jpg": 559,
	"./dogs/puppy_weight/Miniature Schnauzer": 560,
	"./dogs/puppy_weight/Miniature Schnauzer.jpg": 560,
	"./dogs/puppy_weight/Newfoundland": 561,
	"./dogs/puppy_weight/Newfoundland.jpg": 561,
	"./dogs/puppy_weight/Nova Scotia Duck Tolling Retriever": 562,
	"./dogs/puppy_weight/Nova Scotia Duck Tolling Retriever.jpg": 562,
	"./dogs/puppy_weight/Old English Sheepdog": 563,
	"./dogs/puppy_weight/Old English Sheepdog.jpg": 563,
	"./dogs/puppy_weight/Old German Shepherd Dog": 564,
	"./dogs/puppy_weight/Old German Shepherd Dog.jpg": 564,
	"./dogs/puppy_weight/Papillon": 565,
	"./dogs/puppy_weight/Papillon.jpg": 565,
	"./dogs/puppy_weight/Pekingese": 566,
	"./dogs/puppy_weight/Pekingese.jpg": 566,
	"./dogs/puppy_weight/Pembroke Welsh Corgi": 567,
	"./dogs/puppy_weight/Pembroke Welsh Corgi.jpg": 567,
	"./dogs/puppy_weight/Petit Basset Griffon Vendéen": 568,
	"./dogs/puppy_weight/Petit Basset Griffon Vendéen.jpg": 568,
	"./dogs/puppy_weight/Pocket Beagle": 569,
	"./dogs/puppy_weight/Pocket Beagle.jpg": 569,
	"./dogs/puppy_weight/Polish Lowland Sheepdog": 570,
	"./dogs/puppy_weight/Polish Lowland Sheepdog.jpg": 570,
	"./dogs/puppy_weight/Polish Tatra Sheepdog": 571,
	"./dogs/puppy_weight/Polish Tatra Sheepdog.jpg": 571,
	"./dogs/puppy_weight/Pomeranian": 572,
	"./dogs/puppy_weight/Pomeranian.jpg": 572,
	"./dogs/puppy_weight/Poodle": 573,
	"./dogs/puppy_weight/Poodle.jpg": 573,
	"./dogs/puppy_weight/Portuguese Water Dog": 574,
	"./dogs/puppy_weight/Portuguese Water Dog.jpg": 574,
	"./dogs/puppy_weight/Pug": 575,
	"./dogs/puppy_weight/Pug.jpg": 575,
	"./dogs/puppy_weight/Pyrenean Shepherd": 576,
	"./dogs/puppy_weight/Pyrenean Shepherd.jpg": 576,
	"./dogs/puppy_weight/Rhodesian Ridgeback": 577,
	"./dogs/puppy_weight/Rhodesian Ridgeback.jpg": 577,
	"./dogs/puppy_weight/Rottweiler": 578,
	"./dogs/puppy_weight/Rottweiler.jpg": 578,
	"./dogs/puppy_weight/Rough Collie": 579,
	"./dogs/puppy_weight/Rough Collie.jpg": 579,
	"./dogs/puppy_weight/Russkiy Toy": 580,
	"./dogs/puppy_weight/Russkiy Toy.jpg": 580,
	"./dogs/puppy_weight/Saint Bernard": 581,
	"./dogs/puppy_weight/Saint Bernard.jpg": 581,
	"./dogs/puppy_weight/Saluki": 582,
	"./dogs/puppy_weight/Saluki.jpg": 582,
	"./dogs/puppy_weight/Shetland Sheepdog": 583,
	"./dogs/puppy_weight/Shetland Sheepdog.jpg": 583,
	"./dogs/puppy_weight/Shih Tzu": 584,
	"./dogs/puppy_weight/Shih Tzu.jpg": 584,
	"./dogs/puppy_weight/Siberian Husky": 585,
	"./dogs/puppy_weight/Siberian Husky.jpg": 585,
	"./dogs/puppy_weight/Skye Terrier": 586,
	"./dogs/puppy_weight/Skye Terrier.jpg": 586,
	"./dogs/puppy_weight/Small Andalusian Hound": 587,
	"./dogs/puppy_weight/Small Andalusian Hound.jpg": 587,
	"./dogs/puppy_weight/Small Münsterländer": 588,
	"./dogs/puppy_weight/Small Münsterländer.jpg": 588,
	"./dogs/puppy_weight/Smooth Collie": 589,
	"./dogs/puppy_weight/Smooth Collie.jpg": 589,
	"./dogs/puppy_weight/Soft-Coated Wheaten Terrier": 590,
	"./dogs/puppy_weight/Soft-Coated Wheaten Terrier.jpg": 590,
	"./dogs/puppy_weight/Stabyhoun": 591,
	"./dogs/puppy_weight/Stabyhoun.jpg": 591,
	"./dogs/puppy_weight/Staffordshire Bull Terrier": 592,
	"./dogs/puppy_weight/Staffordshire Bull Terrier.jpg": 592,
	"./dogs/puppy_weight/Standard Schnauzer": 593,
	"./dogs/puppy_weight/Standard Schnauzer.jpg": 593,
	"./dogs/puppy_weight/Teacup Yorkshire Terrier": 594,
	"./dogs/puppy_weight/Teacup Yorkshire Terrier.jpg": 594,
	"./dogs/puppy_weight/Thai Ridgeback": 595,
	"./dogs/puppy_weight/Thai Ridgeback.jpg": 595,
	"./dogs/puppy_weight/Tibetan Mastiff": 596,
	"./dogs/puppy_weight/Tibetan Mastiff.jpg": 596,
	"./dogs/puppy_weight/Tibetan Spaniel": 597,
	"./dogs/puppy_weight/Tibetan Spaniel.jpg": 597,
	"./dogs/puppy_weight/Tibetan Terrier": 598,
	"./dogs/puppy_weight/Tibetan Terrier.jpg": 598,
	"./dogs/puppy_weight/Toy Fox Terrier": 599,
	"./dogs/puppy_weight/Toy Fox Terrier.jpg": 599,
	"./dogs/puppy_weight/Toy Poodle": 600,
	"./dogs/puppy_weight/Toy Poodle.jpg": 600,
	"./dogs/puppy_weight/Vizsla": 601,
	"./dogs/puppy_weight/Vizsla.jpg": 601,
	"./dogs/puppy_weight/Weimaraner": 602,
	"./dogs/puppy_weight/Weimaraner.jpg": 602,
	"./dogs/puppy_weight/Welsh Terrier": 603,
	"./dogs/puppy_weight/Welsh Terrier.jpg": 603,
	"./dogs/puppy_weight/West Highland White Terrier": 604,
	"./dogs/puppy_weight/West Highland White Terrier.jpg": 604,
	"./dogs/puppy_weight/Whippet": 605,
	"./dogs/puppy_weight/Whippet.jpg": 605,
	"./dogs/puppy_weight/Wire Fox Terrier": 606,
	"./dogs/puppy_weight/Wire Fox Terrier.jpg": 606,
	"./dogs/puppy_weight/Wirehaired Pointing Griffon": 607,
	"./dogs/puppy_weight/Wirehaired Pointing Griffon.jpg": 607,
	"./dogs/puppy_weight/Wirehaired Vizsla": 608,
	"./dogs/puppy_weight/Wirehaired Vizsla.jpg": 608,
	"./dogs/puppy_weight/Xoloitzcuintli": 609,
	"./dogs/puppy_weight/Xoloitzcuintli.jpg": 609,
	"./dogs/puppy_weight/Yorkshire Terrier": 610,
	"./dogs/puppy_weight/Yorkshire Terrier.jpg": 610,
	"./dogs/puppy_weight/Šarplaninac": 611,
	"./dogs/puppy_weight/Šarplaninac.jpg": 611,
	"./dogs/puppy_weight_cropped/Affenpinscher": 612,
	"./dogs/puppy_weight_cropped/Affenpinscher.jpg": 612,
	"./dogs/puppy_weight_cropped/Afghan Hound": 613,
	"./dogs/puppy_weight_cropped/Afghan Hound.jpg": 613,
	"./dogs/puppy_weight_cropped/Airedale Terrier": 614,
	"./dogs/puppy_weight_cropped/Airedale Terrier.jpg": 614,
	"./dogs/puppy_weight_cropped/Akita": 615,
	"./dogs/puppy_weight_cropped/Akita.jpg": 615,
	"./dogs/puppy_weight_cropped/Alano Español": 616,
	"./dogs/puppy_weight_cropped/Alano Español.jpg": 616,
	"./dogs/puppy_weight_cropped/Alaskan Malamute": 617,
	"./dogs/puppy_weight_cropped/Alaskan Malamute.jpg": 617,
	"./dogs/puppy_weight_cropped/Alpine Dachsbracke": 618,
	"./dogs/puppy_weight_cropped/Alpine Dachsbracke.jpg": 618,
	"./dogs/puppy_weight_cropped/American Akita": 619,
	"./dogs/puppy_weight_cropped/American Akita.jpg": 619,
	"./dogs/puppy_weight_cropped/American Bulldog": 620,
	"./dogs/puppy_weight_cropped/American Bulldog.jpg": 620,
	"./dogs/puppy_weight_cropped/American Bully": 621,
	"./dogs/puppy_weight_cropped/American Bully.jpg": 621,
	"./dogs/puppy_weight_cropped/American Cocker Spaniel": 622,
	"./dogs/puppy_weight_cropped/American Cocker Spaniel.jpg": 622,
	"./dogs/puppy_weight_cropped/American Hairless Terrier": 623,
	"./dogs/puppy_weight_cropped/American Hairless Terrier.jpg": 623,
	"./dogs/puppy_weight_cropped/American Pit Bull Terrier": 624,
	"./dogs/puppy_weight_cropped/American Pit Bull Terrier.jpg": 624,
	"./dogs/puppy_weight_cropped/American Staffordshire Terrier": 625,
	"./dogs/puppy_weight_cropped/American Staffordshire Terrier.jpg": 625,
	"./dogs/puppy_weight_cropped/Anatolian Shepherd Dog": 626,
	"./dogs/puppy_weight_cropped/Anatolian Shepherd Dog.jpg": 626,
	"./dogs/puppy_weight_cropped/Andalusian Hound (Medium)": 627,
	"./dogs/puppy_weight_cropped/Andalusian Hound (Medium).jpg": 627,
	"./dogs/puppy_weight_cropped/Appenzeller Sennenhund": 628,
	"./dogs/puppy_weight_cropped/Appenzeller Sennenhund.jpg": 628,
	"./dogs/puppy_weight_cropped/Australian Cattle Dog": 629,
	"./dogs/puppy_weight_cropped/Australian Cattle Dog.jpg": 629,
	"./dogs/puppy_weight_cropped/Australian Shepherd": 630,
	"./dogs/puppy_weight_cropped/Australian Shepherd.jpg": 630,
	"./dogs/puppy_weight_cropped/Australian Terrier": 631,
	"./dogs/puppy_weight_cropped/Australian Terrier.jpg": 631,
	"./dogs/puppy_weight_cropped/Barbado da Terceira": 632,
	"./dogs/puppy_weight_cropped/Barbado da Terceira.jpg": 632,
	"./dogs/puppy_weight_cropped/Barbet": 633,
	"./dogs/puppy_weight_cropped/Barbet.jpg": 633,
	"./dogs/puppy_weight_cropped/Basenji": 634,
	"./dogs/puppy_weight_cropped/Basenji.jpg": 634,
	"./dogs/puppy_weight_cropped/Basset Fauve de Bretagne": 635,
	"./dogs/puppy_weight_cropped/Basset Fauve de Bretagne.jpg": 635,
	"./dogs/puppy_weight_cropped/Basset Hound": 636,
	"./dogs/puppy_weight_cropped/Basset Hound.jpg": 636,
	"./dogs/puppy_weight_cropped/Beagle": 637,
	"./dogs/puppy_weight_cropped/Beagle.jpg": 637,
	"./dogs/puppy_weight_cropped/Bearded Collie": 638,
	"./dogs/puppy_weight_cropped/Bearded Collie.jpg": 638,
	"./dogs/puppy_weight_cropped/Beauceron": 639,
	"./dogs/puppy_weight_cropped/Beauceron.jpg": 639,
	"./dogs/puppy_weight_cropped/Bedlington Terrier": 640,
	"./dogs/puppy_weight_cropped/Bedlington Terrier.jpg": 640,
	"./dogs/puppy_weight_cropped/Belgian Shepherd Dog (Groenendael)": 641,
	"./dogs/puppy_weight_cropped/Belgian Shepherd Dog (Groenendael).jpg": 641,
	"./dogs/puppy_weight_cropped/Belgian Shepherd Dog (Laekenois)": 642,
	"./dogs/puppy_weight_cropped/Belgian Shepherd Dog (Laekenois).jpg": 642,
	"./dogs/puppy_weight_cropped/Belgian Shepherd Dog (Malinois)": 643,
	"./dogs/puppy_weight_cropped/Belgian Shepherd Dog (Malinois).jpg": 643,
	"./dogs/puppy_weight_cropped/Belgian Shepherd Dog (Tervuren)": 644,
	"./dogs/puppy_weight_cropped/Belgian Shepherd Dog (Tervuren).jpg": 644,
	"./dogs/puppy_weight_cropped/Berger Blanc Suisse": 645,
	"./dogs/puppy_weight_cropped/Berger Blanc Suisse.jpg": 645,
	"./dogs/puppy_weight_cropped/Berger Picard": 646,
	"./dogs/puppy_weight_cropped/Berger Picard.jpg": 646,
	"./dogs/puppy_weight_cropped/Bernese Mountain Dog": 647,
	"./dogs/puppy_weight_cropped/Bernese Mountain Dog.jpg": 647,
	"./dogs/puppy_weight_cropped/Bichon Frise": 648,
	"./dogs/puppy_weight_cropped/Bichon Frise.jpg": 648,
	"./dogs/puppy_weight_cropped/Biewer Terrier": 649,
	"./dogs/puppy_weight_cropped/Biewer Terrier.jpg": 649,
	"./dogs/puppy_weight_cropped/Boerboel": 650,
	"./dogs/puppy_weight_cropped/Boerboel.jpg": 650,
	"./dogs/puppy_weight_cropped/Bohemian Shepherd": 651,
	"./dogs/puppy_weight_cropped/Bohemian Shepherd.jpg": 651,
	"./dogs/puppy_weight_cropped/Bolognese": 652,
	"./dogs/puppy_weight_cropped/Bolognese.jpg": 652,
	"./dogs/puppy_weight_cropped/Bolonka Zwetna": 653,
	"./dogs/puppy_weight_cropped/Bolonka Zwetna.jpg": 653,
	"./dogs/puppy_weight_cropped/Border Collie": 654,
	"./dogs/puppy_weight_cropped/Border Collie.jpg": 654,
	"./dogs/puppy_weight_cropped/Border Terrier": 655,
	"./dogs/puppy_weight_cropped/Border Terrier.jpg": 655,
	"./dogs/puppy_weight_cropped/Borzoi": 656,
	"./dogs/puppy_weight_cropped/Borzoi.jpg": 656,
	"./dogs/puppy_weight_cropped/Boston Terrier": 657,
	"./dogs/puppy_weight_cropped/Boston Terrier.jpg": 657,
	"./dogs/puppy_weight_cropped/Bouvier des Ardennes": 658,
	"./dogs/puppy_weight_cropped/Bouvier des Ardennes.jpg": 658,
	"./dogs/puppy_weight_cropped/Bouvier des Flandres": 659,
	"./dogs/puppy_weight_cropped/Bouvier des Flandres.jpg": 659,
	"./dogs/puppy_weight_cropped/Boxer": 660,
	"./dogs/puppy_weight_cropped/Boxer.jpg": 660,
	"./dogs/puppy_weight_cropped/Braque Francais": 661,
	"./dogs/puppy_weight_cropped/Braque Francais.jpg": 661,
	"./dogs/puppy_weight_cropped/Brazilian Terrier": 662,
	"./dogs/puppy_weight_cropped/Brazilian Terrier.jpg": 662,
	"./dogs/puppy_weight_cropped/Briard": 663,
	"./dogs/puppy_weight_cropped/Briard.jpg": 663,
	"./dogs/puppy_weight_cropped/Brittany": 664,
	"./dogs/puppy_weight_cropped/Brittany.jpg": 664,
	"./dogs/puppy_weight_cropped/Brussels Griffon": 665,
	"./dogs/puppy_weight_cropped/Brussels Griffon.jpg": 665,
	"./dogs/puppy_weight_cropped/Bucovina Shepherd Dog": 666,
	"./dogs/puppy_weight_cropped/Bucovina Shepherd Dog.jpg": 666,
	"./dogs/puppy_weight_cropped/Bull Terrier": 667,
	"./dogs/puppy_weight_cropped/Bull Terrier (Miniature)": 668,
	"./dogs/puppy_weight_cropped/Bull Terrier (Miniature).jpg": 668,
	"./dogs/puppy_weight_cropped/Bull Terrier.jpg": 667,
	"./dogs/puppy_weight_cropped/Bulldog": 669,
	"./dogs/puppy_weight_cropped/Bulldog.jpg": 669,
	"./dogs/puppy_weight_cropped/Bullmastiff": 670,
	"./dogs/puppy_weight_cropped/Bullmastiff.jpg": 670,
	"./dogs/puppy_weight_cropped/Cairn Terrier": 671,
	"./dogs/puppy_weight_cropped/Cairn Terrier.jpg": 671,
	"./dogs/puppy_weight_cropped/Cane Corso": 672,
	"./dogs/puppy_weight_cropped/Cane Corso.jpg": 672,
	"./dogs/puppy_weight_cropped/Cardigan Welsh Corgi": 673,
	"./dogs/puppy_weight_cropped/Cardigan Welsh Corgi.jpg": 673,
	"./dogs/puppy_weight_cropped/Catahoula Leopard Dog": 674,
	"./dogs/puppy_weight_cropped/Catahoula Leopard Dog.jpg": 674,
	"./dogs/puppy_weight_cropped/Catalan Sheepdog": 675,
	"./dogs/puppy_weight_cropped/Catalan Sheepdog.jpg": 675,
	"./dogs/puppy_weight_cropped/Caucasian Shepherd Dog": 676,
	"./dogs/puppy_weight_cropped/Caucasian Shepherd Dog.jpg": 676,
	"./dogs/puppy_weight_cropped/Cavalier King Charles Spaniel": 677,
	"./dogs/puppy_weight_cropped/Cavalier King Charles Spaniel.jpg": 677,
	"./dogs/puppy_weight_cropped/Central Asian Shepherd Dog": 678,
	"./dogs/puppy_weight_cropped/Central Asian Shepherd Dog.jpg": 678,
	"./dogs/puppy_weight_cropped/Chihuahua": 679,
	"./dogs/puppy_weight_cropped/Chihuahua.jpg": 679,
	"./dogs/puppy_weight_cropped/Chinese Crested Dog": 680,
	"./dogs/puppy_weight_cropped/Chinese Crested Dog.jpg": 680,
	"./dogs/puppy_weight_cropped/Chinese Shar-Pei": 681,
	"./dogs/puppy_weight_cropped/Chinese Shar-Pei.jpg": 681,
	"./dogs/puppy_weight_cropped/Chow Chow": 682,
	"./dogs/puppy_weight_cropped/Chow Chow.jpg": 682,
	"./dogs/puppy_weight_cropped/Coton de Tulear": 683,
	"./dogs/puppy_weight_cropped/Coton de Tulear.jpg": 683,
	"./dogs/puppy_weight_cropped/Czechoslovakian Wolfdog": 684,
	"./dogs/puppy_weight_cropped/Czechoslovakian Wolfdog.jpg": 684,
	"./dogs/puppy_weight_cropped/Dachshund": 685,
	"./dogs/puppy_weight_cropped/Dachshund.jpg": 685,
	"./dogs/puppy_weight_cropped/Dalmatian": 686,
	"./dogs/puppy_weight_cropped/Dalmatian.jpg": 686,
	"./dogs/puppy_weight_cropped/Dogue de Bordeaux": 687,
	"./dogs/puppy_weight_cropped/Dogue de Bordeaux.jpg": 687,
	"./dogs/puppy_weight_cropped/Dutch Shepherd Dog": 688,
	"./dogs/puppy_weight_cropped/Dutch Shepherd Dog.jpg": 688,
	"./dogs/puppy_weight_cropped/East-European Shepherd": 689,
	"./dogs/puppy_weight_cropped/East-European Shepherd.jpg": 689,
	"./dogs/puppy_weight_cropped/English Cocker Spaniel": 690,
	"./dogs/puppy_weight_cropped/English Cocker Spaniel.jpg": 690,
	"./dogs/puppy_weight_cropped/English Mastiff": 691,
	"./dogs/puppy_weight_cropped/English Mastiff.jpg": 691,
	"./dogs/puppy_weight_cropped/English Springer Spaniel": 692,
	"./dogs/puppy_weight_cropped/English Springer Spaniel.jpg": 692,
	"./dogs/puppy_weight_cropped/Eurasier": 693,
	"./dogs/puppy_weight_cropped/Eurasier.jpg": 693,
	"./dogs/puppy_weight_cropped/Finnish Lapphund": 694,
	"./dogs/puppy_weight_cropped/Finnish Lapphund.jpg": 694,
	"./dogs/puppy_weight_cropped/Fox Terrier (Smooth)": 695,
	"./dogs/puppy_weight_cropped/Fox Terrier (Smooth).jpg": 695,
	"./dogs/puppy_weight_cropped/German Pinscher": 696,
	"./dogs/puppy_weight_cropped/German Pinscher.jpg": 696,
	"./dogs/puppy_weight_cropped/German Shepherd Dog": 697,
	"./dogs/puppy_weight_cropped/German Shepherd Dog.jpg": 697,
	"./dogs/puppy_weight_cropped/German Shepherd Labrador Retriever Mix": 698,
	"./dogs/puppy_weight_cropped/German Shepherd Labrador Retriever Mix.jpg": 698,
	"./dogs/puppy_weight_cropped/German Shepherd Rottweiler Mix": 699,
	"./dogs/puppy_weight_cropped/German Shepherd Rottweiler Mix.jpg": 699,
	"./dogs/puppy_weight_cropped/German Shorthaired Pointer": 700,
	"./dogs/puppy_weight_cropped/German Shorthaired Pointer.jpg": 700,
	"./dogs/puppy_weight_cropped/Giant German Spitz": 701,
	"./dogs/puppy_weight_cropped/Giant German Spitz.jpg": 701,
	"./dogs/puppy_weight_cropped/Giant Schnauzer": 702,
	"./dogs/puppy_weight_cropped/Giant Schnauzer.jpg": 702,
	"./dogs/puppy_weight_cropped/Golden Retriever": 703,
	"./dogs/puppy_weight_cropped/Golden Retriever.jpg": 703,
	"./dogs/puppy_weight_cropped/Great Pyrenees": 704,
	"./dogs/puppy_weight_cropped/Great Pyrenees.jpg": 704,
	"./dogs/puppy_weight_cropped/Greater Swiss Mountain Dog": 705,
	"./dogs/puppy_weight_cropped/Greater Swiss Mountain Dog.jpg": 705,
	"./dogs/puppy_weight_cropped/Greenland Dog": 706,
	"./dogs/puppy_weight_cropped/Greenland Dog.jpg": 706,
	"./dogs/puppy_weight_cropped/Havanese": 707,
	"./dogs/puppy_weight_cropped/Havanese.jpg": 707,
	"./dogs/puppy_weight_cropped/Hokkaido": 708,
	"./dogs/puppy_weight_cropped/Hokkaido.jpg": 708,
	"./dogs/puppy_weight_cropped/Hovawart": 709,
	"./dogs/puppy_weight_cropped/Hovawart.jpg": 709,
	"./dogs/puppy_weight_cropped/Irish Setter": 710,
	"./dogs/puppy_weight_cropped/Irish Setter.jpg": 710,
	"./dogs/puppy_weight_cropped/Irish Terrier": 711,
	"./dogs/puppy_weight_cropped/Irish Terrier.jpg": 711,
	"./dogs/puppy_weight_cropped/Irish Wolfhound": 712,
	"./dogs/puppy_weight_cropped/Irish Wolfhound.jpg": 712,
	"./dogs/puppy_weight_cropped/Italian Greyhound": 713,
	"./dogs/puppy_weight_cropped/Italian Greyhound.jpg": 713,
	"./dogs/puppy_weight_cropped/Jack Russell Terrier": 714,
	"./dogs/puppy_weight_cropped/Jack Russell Terrier.jpg": 714,
	"./dogs/puppy_weight_cropped/Jagdterrier": 715,
	"./dogs/puppy_weight_cropped/Jagdterrier.jpg": 715,
	"./dogs/puppy_weight_cropped/Japanese Chin": 716,
	"./dogs/puppy_weight_cropped/Japanese Chin.jpg": 716,
	"./dogs/puppy_weight_cropped/Keeshond": 717,
	"./dogs/puppy_weight_cropped/Keeshond.jpg": 717,
	"./dogs/puppy_weight_cropped/Kooikerhondje": 718,
	"./dogs/puppy_weight_cropped/Kooikerhondje.jpg": 718,
	"./dogs/puppy_weight_cropped/Kyi-Leo": 719,
	"./dogs/puppy_weight_cropped/Kyi-Leo.jpg": 719,
	"./dogs/puppy_weight_cropped/Labrador Retriever": 720,
	"./dogs/puppy_weight_cropped/Labrador Retriever.jpg": 720,
	"./dogs/puppy_weight_cropped/Lagotto Romagnolo": 721,
	"./dogs/puppy_weight_cropped/Lagotto Romagnolo.jpg": 721,
	"./dogs/puppy_weight_cropped/Landseer": 722,
	"./dogs/puppy_weight_cropped/Landseer.jpg": 722,
	"./dogs/puppy_weight_cropped/Large Andalusian Hound": 723,
	"./dogs/puppy_weight_cropped/Large Andalusian Hound.jpg": 723,
	"./dogs/puppy_weight_cropped/Large Münsterländer": 724,
	"./dogs/puppy_weight_cropped/Large Münsterländer.jpg": 724,
	"./dogs/puppy_weight_cropped/Leonberger": 725,
	"./dogs/puppy_weight_cropped/Leonberger.jpg": 725,
	"./dogs/puppy_weight_cropped/Lhasa Apso": 726,
	"./dogs/puppy_weight_cropped/Lhasa Apso.jpg": 726,
	"./dogs/puppy_weight_cropped/Löwchen": 727,
	"./dogs/puppy_weight_cropped/Löwchen.jpg": 727,
	"./dogs/puppy_weight_cropped/Maltese": 728,
	"./dogs/puppy_weight_cropped/Maltese Poodle Mix": 729,
	"./dogs/puppy_weight_cropped/Maltese Poodle Mix.jpg": 729,
	"./dogs/puppy_weight_cropped/Maltese.jpg": 728,
	"./dogs/puppy_weight_cropped/Maremma Sheepdog": 730,
	"./dogs/puppy_weight_cropped/Maremma Sheepdog.jpg": 730,
	"./dogs/puppy_weight_cropped/Miniature Australian Shepherd": 731,
	"./dogs/puppy_weight_cropped/Miniature Australian Shepherd.jpg": 731,
	"./dogs/puppy_weight_cropped/Miniature Dachshund": 732,
	"./dogs/puppy_weight_cropped/Miniature Dachshund.jpg": 732,
	"./dogs/puppy_weight_cropped/Miniature Poodle": 733,
	"./dogs/puppy_weight_cropped/Miniature Poodle.jpg": 733,
	"./dogs/puppy_weight_cropped/Miniature Schnauzer": 734,
	"./dogs/puppy_weight_cropped/Miniature Schnauzer.jpg": 734,
	"./dogs/puppy_weight_cropped/Newfoundland": 735,
	"./dogs/puppy_weight_cropped/Newfoundland.jpg": 735,
	"./dogs/puppy_weight_cropped/Nova Scotia Duck Tolling Retriever": 736,
	"./dogs/puppy_weight_cropped/Nova Scotia Duck Tolling Retriever.jpg": 736,
	"./dogs/puppy_weight_cropped/Old English Sheepdog": 737,
	"./dogs/puppy_weight_cropped/Old English Sheepdog.jpg": 737,
	"./dogs/puppy_weight_cropped/Old German Shepherd Dog": 738,
	"./dogs/puppy_weight_cropped/Old German Shepherd Dog.jpg": 738,
	"./dogs/puppy_weight_cropped/Papillon": 739,
	"./dogs/puppy_weight_cropped/Papillon.jpg": 739,
	"./dogs/puppy_weight_cropped/Pekingese": 740,
	"./dogs/puppy_weight_cropped/Pekingese.jpg": 740,
	"./dogs/puppy_weight_cropped/Pembroke Welsh Corgi": 741,
	"./dogs/puppy_weight_cropped/Pembroke Welsh Corgi.jpg": 741,
	"./dogs/puppy_weight_cropped/Petit Basset Griffon Vendéen": 742,
	"./dogs/puppy_weight_cropped/Petit Basset Griffon Vendéen.jpg": 742,
	"./dogs/puppy_weight_cropped/Pocket Beagle": 743,
	"./dogs/puppy_weight_cropped/Pocket Beagle.jpg": 743,
	"./dogs/puppy_weight_cropped/Polish Lowland Sheepdog": 744,
	"./dogs/puppy_weight_cropped/Polish Lowland Sheepdog.jpg": 744,
	"./dogs/puppy_weight_cropped/Polish Tatra Sheepdog": 745,
	"./dogs/puppy_weight_cropped/Polish Tatra Sheepdog.jpg": 745,
	"./dogs/puppy_weight_cropped/Pomeranian": 746,
	"./dogs/puppy_weight_cropped/Pomeranian.jpg": 746,
	"./dogs/puppy_weight_cropped/Poodle": 747,
	"./dogs/puppy_weight_cropped/Poodle.jpg": 747,
	"./dogs/puppy_weight_cropped/Portuguese Water Dog": 748,
	"./dogs/puppy_weight_cropped/Portuguese Water Dog.jpg": 748,
	"./dogs/puppy_weight_cropped/Pug": 749,
	"./dogs/puppy_weight_cropped/Pug.jpg": 749,
	"./dogs/puppy_weight_cropped/Pyrenean Shepherd": 750,
	"./dogs/puppy_weight_cropped/Pyrenean Shepherd.jpg": 750,
	"./dogs/puppy_weight_cropped/Rhodesian Ridgeback": 751,
	"./dogs/puppy_weight_cropped/Rhodesian Ridgeback.jpg": 751,
	"./dogs/puppy_weight_cropped/Rottweiler": 752,
	"./dogs/puppy_weight_cropped/Rottweiler.jpg": 752,
	"./dogs/puppy_weight_cropped/Rough Collie": 753,
	"./dogs/puppy_weight_cropped/Rough Collie.jpg": 753,
	"./dogs/puppy_weight_cropped/Russkiy Toy": 754,
	"./dogs/puppy_weight_cropped/Russkiy Toy.jpg": 754,
	"./dogs/puppy_weight_cropped/Saint Bernard": 755,
	"./dogs/puppy_weight_cropped/Saint Bernard.jpg": 755,
	"./dogs/puppy_weight_cropped/Saluki": 756,
	"./dogs/puppy_weight_cropped/Saluki.jpg": 756,
	"./dogs/puppy_weight_cropped/Shetland Sheepdog": 757,
	"./dogs/puppy_weight_cropped/Shetland Sheepdog.jpg": 757,
	"./dogs/puppy_weight_cropped/Shih Tzu": 758,
	"./dogs/puppy_weight_cropped/Shih Tzu.jpg": 758,
	"./dogs/puppy_weight_cropped/Siberian Husky": 759,
	"./dogs/puppy_weight_cropped/Siberian Husky.jpg": 759,
	"./dogs/puppy_weight_cropped/Skye Terrier": 760,
	"./dogs/puppy_weight_cropped/Skye Terrier.jpg": 760,
	"./dogs/puppy_weight_cropped/Small Andalusian Hound": 761,
	"./dogs/puppy_weight_cropped/Small Andalusian Hound.jpg": 761,
	"./dogs/puppy_weight_cropped/Small Münsterländer": 762,
	"./dogs/puppy_weight_cropped/Small Münsterländer.jpg": 762,
	"./dogs/puppy_weight_cropped/Smooth Collie": 763,
	"./dogs/puppy_weight_cropped/Smooth Collie.jpg": 763,
	"./dogs/puppy_weight_cropped/Soft-Coated Wheaten Terrier": 764,
	"./dogs/puppy_weight_cropped/Soft-Coated Wheaten Terrier.jpg": 764,
	"./dogs/puppy_weight_cropped/Stabyhoun": 765,
	"./dogs/puppy_weight_cropped/Stabyhoun.jpg": 765,
	"./dogs/puppy_weight_cropped/Staffordshire Bull Terrier": 766,
	"./dogs/puppy_weight_cropped/Staffordshire Bull Terrier.jpg": 766,
	"./dogs/puppy_weight_cropped/Standard Schnauzer": 767,
	"./dogs/puppy_weight_cropped/Standard Schnauzer.jpg": 767,
	"./dogs/puppy_weight_cropped/Teacup Yorkshire Terrier": 768,
	"./dogs/puppy_weight_cropped/Teacup Yorkshire Terrier.jpg": 768,
	"./dogs/puppy_weight_cropped/Thai Ridgeback": 769,
	"./dogs/puppy_weight_cropped/Thai Ridgeback.jpg": 769,
	"./dogs/puppy_weight_cropped/Tibetan Mastiff": 770,
	"./dogs/puppy_weight_cropped/Tibetan Mastiff.jpg": 770,
	"./dogs/puppy_weight_cropped/Tibetan Spaniel": 771,
	"./dogs/puppy_weight_cropped/Tibetan Spaniel.jpg": 771,
	"./dogs/puppy_weight_cropped/Tibetan Terrier": 772,
	"./dogs/puppy_weight_cropped/Tibetan Terrier.jpg": 772,
	"./dogs/puppy_weight_cropped/Toy Fox Terrier": 773,
	"./dogs/puppy_weight_cropped/Toy Fox Terrier.jpg": 773,
	"./dogs/puppy_weight_cropped/Toy Poodle": 774,
	"./dogs/puppy_weight_cropped/Toy Poodle.jpg": 774,
	"./dogs/puppy_weight_cropped/Vizsla": 775,
	"./dogs/puppy_weight_cropped/Vizsla.jpg": 775,
	"./dogs/puppy_weight_cropped/Weimaraner": 776,
	"./dogs/puppy_weight_cropped/Weimaraner.jpg": 776,
	"./dogs/puppy_weight_cropped/Welsh Terrier": 777,
	"./dogs/puppy_weight_cropped/Welsh Terrier.jpg": 777,
	"./dogs/puppy_weight_cropped/West Highland White Terrier": 778,
	"./dogs/puppy_weight_cropped/West Highland White Terrier.jpg": 778,
	"./dogs/puppy_weight_cropped/Whippet": 779,
	"./dogs/puppy_weight_cropped/Whippet.jpg": 779,
	"./dogs/puppy_weight_cropped/Wire Fox Terrier": 780,
	"./dogs/puppy_weight_cropped/Wire Fox Terrier.jpg": 780,
	"./dogs/puppy_weight_cropped/Wirehaired Pointing Griffon": 781,
	"./dogs/puppy_weight_cropped/Wirehaired Pointing Griffon.jpg": 781,
	"./dogs/puppy_weight_cropped/Wirehaired Vizsla": 782,
	"./dogs/puppy_weight_cropped/Wirehaired Vizsla.jpg": 782,
	"./dogs/puppy_weight_cropped/Xoloitzcuintli": 783,
	"./dogs/puppy_weight_cropped/Xoloitzcuintli.jpg": 783,
	"./dogs/puppy_weight_cropped/Yorkshire Terrier": 784,
	"./dogs/puppy_weight_cropped/Yorkshire Terrier.jpg": 784,
	"./dogs/puppy_weight_cropped/Šarplaninac": 785,
	"./dogs/puppy_weight_cropped/Šarplaninac.jpg": 785,
	"./dogs/sample_puppy_height_growth": 786,
	"./dogs/sample_puppy_height_growth.jpg": 786,
	"./dogs/supermutt": 787,
	"./dogs/supermutt.jpg": 787,
	"./dogs/underweight_dog": 788,
	"./dogs/underweight_dog.jpg": 788,
	"./dogs_images/afador": 789,
	"./dogs_images/afador.jpg": 789,
	"./dogs_images/affenhuahua": 790,
	"./dogs_images/affenhuahua.jpg": 790,
	"./dogs_images/affenpinscher": 791,
	"./dogs_images/affenpinscher.jpg": 791,
	"./dogs_images/afghan-hound": 792,
	"./dogs_images/afghan-hound.jpg": 792,
	"./dogs_images/airedale-terrier": 793,
	"./dogs_images/airedale-terrier.jpg": 793,
	"./dogs_images/akbash": 794,
	"./dogs_images/akbash.jpg": 794,
	"./dogs_images/akita": 795,
	"./dogs_images/akita-chow": 796,
	"./dogs_images/akita-chow.jpg": 796,
	"./dogs_images/akita-pit": 797,
	"./dogs_images/akita-pit.jpg": 797,
	"./dogs_images/akita-shepherd": 798,
	"./dogs_images/akita-shepherd.jpg": 798,
	"./dogs_images/akita.jpg": 795,
	"./dogs_images/alaskan-klee-kai": 799,
	"./dogs_images/alaskan-klee-kai.jpg": 799,
	"./dogs_images/alaskan-malamute": 800,
	"./dogs_images/alaskan-malamute.jpg": 800,
	"./dogs_images/american-bulldog": 801,
	"./dogs_images/american-bulldog.jpg": 801,
	"./dogs_images/american-english-coonhound": 802,
	"./dogs_images/american-english-coonhound.jpg": 802,
	"./dogs_images/american-eskimo-dog": 803,
	"./dogs_images/american-eskimo-dog.jpg": 803,
	"./dogs_images/american-foxhound": 804,
	"./dogs_images/american-foxhound.jpg": 804,
	"./dogs_images/american-leopard-hound": 805,
	"./dogs_images/american-leopard-hound.jpg": 805,
	"./dogs_images/american-pit-bull-terrier": 806,
	"./dogs_images/american-pit-bull-terrier.jpg": 806,
	"./dogs_images/american-pugabull": 807,
	"./dogs_images/american-pugabull.jpg": 807,
	"./dogs_images/american-staffordshire-terrier": 808,
	"./dogs_images/american-staffordshire-terrier.jpg": 808,
	"./dogs_images/american-water-spaniel": 809,
	"./dogs_images/american-water-spaniel.jpg": 809,
	"./dogs_images/anatolian-shepherd-dog": 810,
	"./dogs_images/anatolian-shepherd-dog.jpg": 810,
	"./dogs_images/appenzeller-sennenhunde": 811,
	"./dogs_images/appenzeller-sennenhunde.jpg": 811,
	"./dogs_images/auggie": 812,
	"./dogs_images/auggie.jpg": 812,
	"./dogs_images/aussiedoodle": 813,
	"./dogs_images/aussiedoodle.jpg": 813,
	"./dogs_images/aussiepom": 814,
	"./dogs_images/aussiepom.jpg": 814,
	"./dogs_images/australian-cattle-dog": 815,
	"./dogs_images/australian-cattle-dog.jpg": 815,
	"./dogs_images/australian-kelpie": 816,
	"./dogs_images/australian-kelpie.jpg": 816,
	"./dogs_images/australian-retriever": 817,
	"./dogs_images/australian-retriever.jpg": 817,
	"./dogs_images/australian-shepherd": 818,
	"./dogs_images/australian-shepherd-husky": 819,
	"./dogs_images/australian-shepherd-husky.jpg": 819,
	"./dogs_images/australian-shepherd-lab-mix": 820,
	"./dogs_images/australian-shepherd-lab-mix.jpg": 820,
	"./dogs_images/australian-shepherd-pit-bull-mix": 821,
	"./dogs_images/australian-shepherd-pit-bull-mix.jpg": 821,
	"./dogs_images/australian-shepherd.jpg": 818,
	"./dogs_images/australian-terrier": 822,
	"./dogs_images/australian-terrier.jpg": 822,
	"./dogs_images/azawakh": 823,
	"./dogs_images/azawakh.jpg": 823,
	"./dogs_images/barbet": 824,
	"./dogs_images/barbet.jpg": 824,
	"./dogs_images/basenji": 825,
	"./dogs_images/basenji.jpg": 825,
	"./dogs_images/bassador": 826,
	"./dogs_images/bassador.jpg": 826,
	"./dogs_images/basset-fauve-de-bretagne": 827,
	"./dogs_images/basset-fauve-de-bretagne.jpg": 827,
	"./dogs_images/basset-hound": 828,
	"./dogs_images/basset-hound.jpg": 828,
	"./dogs_images/basset-retriever": 829,
	"./dogs_images/basset-retriever.jpg": 829,
	"./dogs_images/bavarian-mountain-scent-hound": 830,
	"./dogs_images/bavarian-mountain-scent-hound.jpg": 830,
	"./dogs_images/beabull": 831,
	"./dogs_images/beabull.jpg": 831,
	"./dogs_images/beagle": 832,
	"./dogs_images/beagle.jpg": 832,
	"./dogs_images/beaglier": 833,
	"./dogs_images/beaglier.jpg": 833,
	"./dogs_images/bearded-collie": 834,
	"./dogs_images/bearded-collie.jpg": 834,
	"./dogs_images/bedlington-terrier": 835,
	"./dogs_images/bedlington-terrier.jpg": 835,
	"./dogs_images/belgian-malinois": 836,
	"./dogs_images/belgian-malinois.jpg": 836,
	"./dogs_images/belgian-sheepdog": 837,
	"./dogs_images/belgian-sheepdog.jpg": 837,
	"./dogs_images/belgian-tervuren": 838,
	"./dogs_images/belgian-tervuren.jpg": 838,
	"./dogs_images/berger-picard": 839,
	"./dogs_images/berger-picard.jpg": 839,
	"./dogs_images/bernedoodle": 840,
	"./dogs_images/bernedoodle.jpg": 840,
	"./dogs_images/bernese-mountain-dog": 841,
	"./dogs_images/bernese-mountain-dog.jpg": 841,
	"./dogs_images/bichon-frise": 842,
	"./dogs_images/bichon-frise.jpg": 842,
	"./dogs_images/biewer-terrier": 843,
	"./dogs_images/biewer-terrier.jpg": 843,
	"./dogs_images/black-and-tan-coonhound": 844,
	"./dogs_images/black-and-tan-coonhound.jpg": 844,
	"./dogs_images/black-mouth-cur": 845,
	"./dogs_images/black-mouth-cur.jpg": 845,
	"./dogs_images/black-russian-terrier": 846,
	"./dogs_images/black-russian-terrier.jpg": 846,
	"./dogs_images/bloodhound": 847,
	"./dogs_images/bloodhound.jpg": 847,
	"./dogs_images/blue-lacy": 848,
	"./dogs_images/blue-lacy.jpg": 848,
	"./dogs_images/bluetick-coonhound": 849,
	"./dogs_images/bluetick-coonhound.jpg": 849,
	"./dogs_images/bocker": 850,
	"./dogs_images/bocker.jpg": 850,
	"./dogs_images/boerboel": 851,
	"./dogs_images/boerboel.jpg": 851,
	"./dogs_images/boglen-terrier": 852,
	"./dogs_images/boglen-terrier.jpg": 852,
	"./dogs_images/bohemian-shepherd": 853,
	"./dogs_images/bohemian-shepherd.jpg": 853,
	"./dogs_images/bolognese": 854,
	"./dogs_images/bolognese.jpg": 854,
	"./dogs_images/borador": 855,
	"./dogs_images/borador.jpg": 855,
	"./dogs_images/border-collie": 856,
	"./dogs_images/border-collie.jpg": 856,
	"./dogs_images/border-sheepdog": 857,
	"./dogs_images/border-sheepdog.jpg": 857,
	"./dogs_images/border-terrier": 858,
	"./dogs_images/border-terrier.jpg": 858,
	"./dogs_images/bordoodle": 859,
	"./dogs_images/bordoodle.jpg": 859,
	"./dogs_images/borzoi": 860,
	"./dogs_images/borzoi.jpg": 860,
	"./dogs_images/boshih": 861,
	"./dogs_images/boshih.jpg": 861,
	"./dogs_images/bossie": 862,
	"./dogs_images/bossie.jpg": 862,
	"./dogs_images/boston-boxer": 863,
	"./dogs_images/boston-boxer.jpg": 863,
	"./dogs_images/boston-terrier": 864,
	"./dogs_images/boston-terrier.jpg": 864,
	"./dogs_images/bouvier-des-flandres": 865,
	"./dogs_images/bouvier-des-flandres.jpg": 865,
	"./dogs_images/boxador": 866,
	"./dogs_images/boxador.jpg": 866,
	"./dogs_images/boxer": 867,
	"./dogs_images/boxer.jpg": 867,
	"./dogs_images/boxerdoodle": 868,
	"./dogs_images/boxerdoodle.jpg": 868,
	"./dogs_images/boxmatian": 869,
	"./dogs_images/boxmatian.jpg": 869,
	"./dogs_images/boxweiler": 870,
	"./dogs_images/boxweiler.jpg": 870,
	"./dogs_images/boykin-spaniel": 871,
	"./dogs_images/boykin-spaniel.jpg": 871,
	"./dogs_images/bracco-italiano": 872,
	"./dogs_images/bracco-italiano.jpg": 872,
	"./dogs_images/braque-du-bourbonnais": 873,
	"./dogs_images/braque-du-bourbonnais.jpg": 873,
	"./dogs_images/briard": 874,
	"./dogs_images/briard.jpg": 874,
	"./dogs_images/brittany": 875,
	"./dogs_images/brittany.jpg": 875,
	"./dogs_images/broholmer": 876,
	"./dogs_images/broholmer.jpg": 876,
	"./dogs_images/brussels-griffon": 877,
	"./dogs_images/brussels-griffon.jpg": 877,
	"./dogs_images/bugg": 878,
	"./dogs_images/bugg.jpg": 878,
	"./dogs_images/bull-pei": 879,
	"./dogs_images/bull-pei.jpg": 879,
	"./dogs_images/bull-terrier": 880,
	"./dogs_images/bull-terrier.jpg": 880,
	"./dogs_images/bullador": 881,
	"./dogs_images/bullador.jpg": 881,
	"./dogs_images/bullboxer-pit": 882,
	"./dogs_images/bullboxer-pit.jpg": 882,
	"./dogs_images/bulldog": 883,
	"./dogs_images/bulldog.jpg": 883,
	"./dogs_images/bullmastiff": 884,
	"./dogs_images/bullmastiff.jpg": 884,
	"./dogs_images/bullmatian": 885,
	"./dogs_images/bullmatian.jpg": 885,
	"./dogs_images/cairn-terrier": 886,
	"./dogs_images/cairn-terrier.jpg": 886,
	"./dogs_images/canaan-dog": 887,
	"./dogs_images/canaan-dog.jpg": 887,
	"./dogs_images/cane-corso": 888,
	"./dogs_images/cane-corso.jpg": 888,
	"./dogs_images/cardigan-welsh-corgi": 889,
	"./dogs_images/cardigan-welsh-corgi.jpg": 889,
	"./dogs_images/catahoula-bulldog": 890,
	"./dogs_images/catahoula-bulldog.jpg": 890,
	"./dogs_images/catahoula-leopard-dog": 891,
	"./dogs_images/catahoula-leopard-dog.jpg": 891,
	"./dogs_images/caucasian-shepherd-dog": 892,
	"./dogs_images/caucasian-shepherd-dog.jpg": 892,
	"./dogs_images/cav-a-jack": 893,
	"./dogs_images/cav-a-jack.jpg": 893,
	"./dogs_images/cavachon": 894,
	"./dogs_images/cavachon.jpg": 894,
	"./dogs_images/cavador": 895,
	"./dogs_images/cavador.jpg": 895,
	"./dogs_images/cavalier-king-charles-spaniel": 896,
	"./dogs_images/cavalier-king-charles-spaniel.jpg": 896,
	"./dogs_images/cavapoo": 897,
	"./dogs_images/cavapoo.jpg": 897,
	"./dogs_images/cesky-terrier": 898,
	"./dogs_images/cesky-terrier.jpg": 898,
	"./dogs_images/chabrador": 899,
	"./dogs_images/chabrador.jpg": 899,
	"./dogs_images/cheagle": 900,
	"./dogs_images/cheagle.jpg": 900,
	"./dogs_images/chesapeake-bay-retriever": 901,
	"./dogs_images/chesapeake-bay-retriever.jpg": 901,
	"./dogs_images/chi-chi": 902,
	"./dogs_images/chi-chi.jpg": 902,
	"./dogs_images/chi-poo": 903,
	"./dogs_images/chi-poo.jpg": 903,
	"./dogs_images/chigi": 904,
	"./dogs_images/chigi.jpg": 904,
	"./dogs_images/chihuahua": 905,
	"./dogs_images/chihuahua.jpg": 905,
	"./dogs_images/chilier": 906,
	"./dogs_images/chilier.jpg": 906,
	"./dogs_images/chinese-crested": 907,
	"./dogs_images/chinese-crested.jpg": 907,
	"./dogs_images/chinese-shar-pei": 908,
	"./dogs_images/chinese-shar-pei.jpg": 908,
	"./dogs_images/chinook": 909,
	"./dogs_images/chinook.jpg": 909,
	"./dogs_images/chion": 910,
	"./dogs_images/chion.jpg": 910,
	"./dogs_images/chipin": 911,
	"./dogs_images/chipin.jpg": 911,
	"./dogs_images/chiweenie": 912,
	"./dogs_images/chiweenie.jpg": 912,
	"./dogs_images/chorkie": 913,
	"./dogs_images/chorkie.jpg": 913,
	"./dogs_images/chow-chow": 914,
	"./dogs_images/chow-chow.jpg": 914,
	"./dogs_images/chow-shepherd": 915,
	"./dogs_images/chow-shepherd.jpg": 915,
	"./dogs_images/chug": 916,
	"./dogs_images/chug.jpg": 916,
	"./dogs_images/chusky": 917,
	"./dogs_images/chusky.jpg": 917,
	"./dogs_images/cirneco-dell-etna": 918,
	"./dogs_images/cirneco-dell-etna.jpg": 918,
	"./dogs_images/clumber-spaniel": 919,
	"./dogs_images/clumber-spaniel.jpg": 919,
	"./dogs_images/cockalier": 920,
	"./dogs_images/cockalier.jpg": 920,
	"./dogs_images/cockapoo": 921,
	"./dogs_images/cockapoo.jpg": 921,
	"./dogs_images/cocker-spaniel": 922,
	"./dogs_images/cocker-spaniel.jpg": 922,
	"./dogs_images/collie": 923,
	"./dogs_images/collie.jpg": 923,
	"./dogs_images/corgi-inu": 924,
	"./dogs_images/corgi-inu.jpg": 924,
	"./dogs_images/corgidor": 925,
	"./dogs_images/corgidor.jpg": 925,
	"./dogs_images/corman-shepherd": 926,
	"./dogs_images/corman-shepherd.jpg": 926,
	"./dogs_images/coton-de-tulear": 927,
	"./dogs_images/coton-de-tulear.jpg": 927,
	"./dogs_images/curly-coated-retriever": 928,
	"./dogs_images/curly-coated-retriever.jpg": 928,
	"./dogs_images/dachsador": 929,
	"./dogs_images/dachsador.jpg": 929,
	"./dogs_images/dachshund": 930,
	"./dogs_images/dachshund.jpg": 930,
	"./dogs_images/dalmatian": 931,
	"./dogs_images/dalmatian.jpg": 931,
	"./dogs_images/dandie-dinmont-terrier": 932,
	"./dogs_images/dandie-dinmont-terrier.jpg": 932,
	"./dogs_images/daniff": 933,
	"./dogs_images/daniff.jpg": 933,
	"./dogs_images/deutscher-wachtelhund": 934,
	"./dogs_images/deutscher-wachtelhund.jpg": 934,
	"./dogs_images/doberdor": 935,
	"./dogs_images/doberdor.jpg": 935,
	"./dogs_images/doberman-pinscher": 936,
	"./dogs_images/doberman-pinscher.jpg": 936,
	"./dogs_images/docker": 937,
	"./dogs_images/docker.jpg": 937,
	"./dogs_images/dogo-argentino": 938,
	"./dogs_images/dogo-argentino.jpg": 938,
	"./dogs_images/dogue-de-bordeaux": 939,
	"./dogs_images/dogue-de-bordeaux.jpg": 939,
	"./dogs_images/dorgi": 940,
	"./dogs_images/dorgi.jpg": 940,
	"./dogs_images/dorkie": 941,
	"./dogs_images/dorkie.jpg": 941,
	"./dogs_images/doxiepoo": 942,
	"./dogs_images/doxiepoo.jpg": 942,
	"./dogs_images/doxle": 943,
	"./dogs_images/doxle.jpg": 943,
	"./dogs_images/drentsche-patrijshond": 944,
	"./dogs_images/drentsche-patrijshond.jpg": 944,
	"./dogs_images/drever": 945,
	"./dogs_images/drever.jpg": 945,
	"./dogs_images/dutch-shepherd": 946,
	"./dogs_images/dutch-shepherd.jpg": 946,
	"./dogs_images/english-cocker-spaniel": 947,
	"./dogs_images/english-cocker-spaniel.jpg": 947,
	"./dogs_images/english-foxhound": 948,
	"./dogs_images/english-foxhound.jpg": 948,
	"./dogs_images/english-setter": 949,
	"./dogs_images/english-setter.jpg": 949,
	"./dogs_images/english-springer-spaniel": 950,
	"./dogs_images/english-springer-spaniel.jpg": 950,
	"./dogs_images/english-toy-spaniel": 951,
	"./dogs_images/english-toy-spaniel.jpg": 951,
	"./dogs_images/entlebucher-mountain-dog": 952,
	"./dogs_images/entlebucher-mountain-dog.jpg": 952,
	"./dogs_images/estrela-mountain-dog": 953,
	"./dogs_images/estrela-mountain-dog.jpg": 953,
	"./dogs_images/eurasier": 954,
	"./dogs_images/eurasier.jpg": 954,
	"./dogs_images/field-spaniel": 955,
	"./dogs_images/field-spaniel.jpg": 955,
	"./dogs_images/finnish-lapphund": 956,
	"./dogs_images/finnish-lapphund.jpg": 956,
	"./dogs_images/finnish-spitz": 957,
	"./dogs_images/finnish-spitz.jpg": 957,
	"./dogs_images/flat-coated-retriever": 958,
	"./dogs_images/flat-coated-retriever.jpg": 958,
	"./dogs_images/fox-terrier": 959,
	"./dogs_images/fox-terrier.jpg": 959,
	"./dogs_images/french-bulldog": 960,
	"./dogs_images/french-bulldog.jpg": 960,
	"./dogs_images/french-bullhuahua": 961,
	"./dogs_images/french-bullhuahua.jpg": 961,
	"./dogs_images/french-spaniel": 962,
	"./dogs_images/french-spaniel.jpg": 962,
	"./dogs_images/frenchton": 963,
	"./dogs_images/frenchton.jpg": 963,
	"./dogs_images/frengle": 964,
	"./dogs_images/frengle.jpg": 964,
	"./dogs_images/german-pinscher": 965,
	"./dogs_images/german-pinscher.jpg": 965,
	"./dogs_images/german-shepherd-dog": 966,
	"./dogs_images/german-shepherd-dog.jpg": 966,
	"./dogs_images/german-shepherd-pit-bull": 967,
	"./dogs_images/german-shepherd-pit-bull.jpg": 967,
	"./dogs_images/german-sheprador": 968,
	"./dogs_images/german-sheprador.jpg": 968,
	"./dogs_images/german-shorthaired-pointer": 969,
	"./dogs_images/german-shorthaired-pointer.jpg": 969,
	"./dogs_images/german-spitz": 970,
	"./dogs_images/german-spitz.jpg": 970,
	"./dogs_images/german-wirehaired-pointer": 971,
	"./dogs_images/german-wirehaired-pointer.jpg": 971,
	"./dogs_images/giant-schnauzer": 972,
	"./dogs_images/giant-schnauzer.jpg": 972,
	"./dogs_images/glen-of-imaal-terrier": 973,
	"./dogs_images/glen-of-imaal-terrier.jpg": 973,
	"./dogs_images/goberian": 974,
	"./dogs_images/goberian.jpg": 974,
	"./dogs_images/goldador": 975,
	"./dogs_images/goldador.jpg": 975,
	"./dogs_images/golden-cocker-retriever": 976,
	"./dogs_images/golden-cocker-retriever.jpg": 976,
	"./dogs_images/golden-mountain-dog": 977,
	"./dogs_images/golden-mountain-dog.jpg": 977,
	"./dogs_images/golden-retriever": 978,
	"./dogs_images/golden-retriever-corgi": 979,
	"./dogs_images/golden-retriever-corgi.jpg": 979,
	"./dogs_images/golden-retriever.jpg": 978,
	"./dogs_images/golden-shepherd": 980,
	"./dogs_images/golden-shepherd.jpg": 980,
	"./dogs_images/goldendoodle": 981,
	"./dogs_images/goldendoodle.jpg": 981,
	"./dogs_images/gollie": 982,
	"./dogs_images/gollie.jpg": 982,
	"./dogs_images/gordon-setter": 983,
	"./dogs_images/gordon-setter.jpg": 983,
	"./dogs_images/great-dane": 984,
	"./dogs_images/great-dane.jpg": 984,
	"./dogs_images/great-pyrenees": 985,
	"./dogs_images/great-pyrenees.jpg": 985,
	"./dogs_images/greater-swiss-mountain-dog": 986,
	"./dogs_images/greater-swiss-mountain-dog.jpg": 986,
	"./dogs_images/greyador": 987,
	"./dogs_images/greyador.jpg": 987,
	"./dogs_images/greyhound": 988,
	"./dogs_images/greyhound.jpg": 988,
	"./dogs_images/hamiltonstovare": 989,
	"./dogs_images/hamiltonstovare.jpg": 989,
	"./dogs_images/hanoverian-scenthound": 990,
	"./dogs_images/hanoverian-scenthound.jpg": 990,
	"./dogs_images/harrier": 991,
	"./dogs_images/harrier.jpg": 991,
	"./dogs_images/havanese": 992,
	"./dogs_images/havanese.jpg": 992,
	"./dogs_images/hokkaido": 993,
	"./dogs_images/hokkaido.jpg": 993,
	"./dogs_images/horgi": 994,
	"./dogs_images/horgi.jpg": 994,
	"./dogs_images/huskita": 995,
	"./dogs_images/huskita.jpg": 995,
	"./dogs_images/huskydoodle": 996,
	"./dogs_images/huskydoodle.jpg": 996,
	"./dogs_images/ibizan-hound": 997,
	"./dogs_images/ibizan-hound.jpg": 997,
	"./dogs_images/icelandic-sheepdog": 998,
	"./dogs_images/icelandic-sheepdog.jpg": 998,
	"./dogs_images/irish-red-and-white-setter": 999,
	"./dogs_images/irish-red-and-white-setter.jpg": 999,
	"./dogs_images/irish-setter": 1000,
	"./dogs_images/irish-setter.jpg": 1000,
	"./dogs_images/irish-terrier": 1001,
	"./dogs_images/irish-terrier.jpg": 1001,
	"./dogs_images/irish-water-spaniel": 1002,
	"./dogs_images/irish-water-spaniel.jpg": 1002,
	"./dogs_images/irish-wolfhound": 1003,
	"./dogs_images/irish-wolfhound.jpg": 1003,
	"./dogs_images/italian-greyhound": 1004,
	"./dogs_images/italian-greyhound.jpg": 1004,
	"./dogs_images/jack-a-poo": 1005,
	"./dogs_images/jack-a-poo.jpg": 1005,
	"./dogs_images/jack-chi": 1006,
	"./dogs_images/jack-chi.jpg": 1006,
	"./dogs_images/jack-russell-terrier": 1007,
	"./dogs_images/jack-russell-terrier.jpg": 1007,
	"./dogs_images/jackshund": 1008,
	"./dogs_images/jackshund.jpg": 1008,
	"./dogs_images/japanese-chin": 1009,
	"./dogs_images/japanese-chin.jpg": 1009,
	"./dogs_images/japanese-spitz": 1010,
	"./dogs_images/japanese-spitz.jpg": 1010,
	"./dogs_images/karelian-bear-dog": 1011,
	"./dogs_images/karelian-bear-dog.jpg": 1011,
	"./dogs_images/keeshond": 1012,
	"./dogs_images/keeshond.jpg": 1012,
	"./dogs_images/kerry-blue-terrier": 1013,
	"./dogs_images/kerry-blue-terrier.jpg": 1013,
	"./dogs_images/king-shepherd": 1014,
	"./dogs_images/king-shepherd.jpg": 1014,
	"./dogs_images/komondor": 1015,
	"./dogs_images/komondor.jpg": 1015,
	"./dogs_images/kooikerhondje": 1016,
	"./dogs_images/kooikerhondje.jpg": 1016,
	"./dogs_images/korean-jindo-dog": 1017,
	"./dogs_images/korean-jindo-dog.jpg": 1017,
	"./dogs_images/kuvasz": 1018,
	"./dogs_images/kuvasz.jpg": 1018,
	"./dogs_images/kyi-leo": 1019,
	"./dogs_images/kyi-leo.jpg": 1019,
	"./dogs_images/lab-pointer": 1020,
	"./dogs_images/lab-pointer.jpg": 1020,
	"./dogs_images/labernese": 1021,
	"./dogs_images/labernese.jpg": 1021,
	"./dogs_images/labmaraner": 1022,
	"./dogs_images/labmaraner.jpg": 1022,
	"./dogs_images/labrabull": 1023,
	"./dogs_images/labrabull.jpg": 1023,
	"./dogs_images/labradane": 1024,
	"./dogs_images/labradane.jpg": 1024,
	"./dogs_images/labradoodle": 1025,
	"./dogs_images/labradoodle.jpg": 1025,
	"./dogs_images/labrador-retriever": 1026,
	"./dogs_images/labrador-retriever.jpg": 1026,
	"./dogs_images/labrastaff": 1027,
	"./dogs_images/labrastaff.jpg": 1027,
	"./dogs_images/labsky": 1028,
	"./dogs_images/labsky.jpg": 1028,
	"./dogs_images/lagotto-romagnolo": 1029,
	"./dogs_images/lagotto-romagnolo.jpg": 1029,
	"./dogs_images/lakeland-terrier": 1030,
	"./dogs_images/lakeland-terrier.jpg": 1030,
	"./dogs_images/lancashire-heeler": 1031,
	"./dogs_images/lancashire-heeler.jpg": 1031,
	"./dogs_images/leonberger": 1032,
	"./dogs_images/leonberger.jpg": 1032,
	"./dogs_images/lhasa-apso": 1033,
	"./dogs_images/lhasa-apso.jpg": 1033,
	"./dogs_images/lhasapoo": 1034,
	"./dogs_images/lhasapoo.jpg": 1034,
	"./dogs_images/lowchen": 1035,
	"./dogs_images/lowchen.jpg": 1035,
	"./dogs_images/maltese": 1036,
	"./dogs_images/maltese-shih-tzu": 1037,
	"./dogs_images/maltese-shih-tzu.jpg": 1037,
	"./dogs_images/maltese.jpg": 1036,
	"./dogs_images/maltipoo": 1038,
	"./dogs_images/maltipoo.jpg": 1038,
	"./dogs_images/manchester-terrier": 1039,
	"./dogs_images/manchester-terrier.jpg": 1039,
	"./dogs_images/mastador": 1040,
	"./dogs_images/mastador.jpg": 1040,
	"./dogs_images/mastiff": 1041,
	"./dogs_images/mastiff.jpg": 1041,
	"./dogs_images/miniature-pinscher": 1042,
	"./dogs_images/miniature-pinscher.jpg": 1042,
	"./dogs_images/miniature-schnauzer": 1043,
	"./dogs_images/miniature-schnauzer.jpg": 1043,
	"./dogs_images/morkie": 1044,
	"./dogs_images/morkie.jpg": 1044,
	"./dogs_images/mudi": 1045,
	"./dogs_images/mudi.jpg": 1045,
	"./dogs_images/mutt": 1046,
	"./dogs_images/mutt.jpg": 1046,
	"./dogs_images/neapolitan-mastiff": 1047,
	"./dogs_images/neapolitan-mastiff.jpg": 1047,
	"./dogs_images/newfoundland": 1048,
	"./dogs_images/newfoundland.jpg": 1048,
	"./dogs_images/norfolk-terrier": 1049,
	"./dogs_images/norfolk-terrier.jpg": 1049,
	"./dogs_images/norwegian-buhund": 1050,
	"./dogs_images/norwegian-buhund.jpg": 1050,
	"./dogs_images/norwegian-elkhound": 1051,
	"./dogs_images/norwegian-elkhound.jpg": 1051,
	"./dogs_images/norwegian-lundehund": 1052,
	"./dogs_images/norwegian-lundehund.jpg": 1052,
	"./dogs_images/norwich-terrier": 1053,
	"./dogs_images/norwich-terrier.jpg": 1053,
	"./dogs_images/nova-scotia-duck-tolling-retriever": 1054,
	"./dogs_images/nova-scotia-duck-tolling-retriever.jpg": 1054,
	"./dogs_images/old-english-sheepdog": 1055,
	"./dogs_images/old-english-sheepdog.jpg": 1055,
	"./dogs_images/otterhound": 1056,
	"./dogs_images/otterhound.jpg": 1056,
	"./dogs_images/papillon": 1057,
	"./dogs_images/papillon.jpg": 1057,
	"./dogs_images/papipoo": 1058,
	"./dogs_images/papipoo.jpg": 1058,
	"./dogs_images/peekapoo": 1059,
	"./dogs_images/peekapoo.jpg": 1059,
	"./dogs_images/pekingese": 1060,
	"./dogs_images/pekingese.jpg": 1060,
	"./dogs_images/pembroke-welsh-corgi": 1061,
	"./dogs_images/pembroke-welsh-corgi.jpg": 1061,
	"./dogs_images/petit-basset-griffon-vendeen": 1062,
	"./dogs_images/petit-basset-griffon-vendeen.jpg": 1062,
	"./dogs_images/pharaoh-hound": 1063,
	"./dogs_images/pharaoh-hound.jpg": 1063,
	"./dogs_images/pitsky": 1064,
	"./dogs_images/pitsky.jpg": 1064,
	"./dogs_images/plott": 1065,
	"./dogs_images/plott.jpg": 1065,
	"./dogs_images/pocket-beagle": 1066,
	"./dogs_images/pocket-beagle.jpg": 1066,
	"./dogs_images/pointer": 1067,
	"./dogs_images/pointer.jpg": 1067,
	"./dogs_images/polish-lowland-sheepdog": 1068,
	"./dogs_images/polish-lowland-sheepdog.jpg": 1068,
	"./dogs_images/pomapoo": 1069,
	"./dogs_images/pomapoo.jpg": 1069,
	"./dogs_images/pomchi": 1070,
	"./dogs_images/pomchi.jpg": 1070,
	"./dogs_images/pomeagle": 1071,
	"./dogs_images/pomeagle.jpg": 1071,
	"./dogs_images/pomeranian": 1072,
	"./dogs_images/pomeranian.jpg": 1072,
	"./dogs_images/pomsky": 1073,
	"./dogs_images/pomsky.jpg": 1073,
	"./dogs_images/poochon": 1074,
	"./dogs_images/poochon.jpg": 1074,
	"./dogs_images/poodle": 1075,
	"./dogs_images/poodle.jpg": 1075,
	"./dogs_images/portuguese-podengo-pequeno": 1076,
	"./dogs_images/portuguese-podengo-pequeno.jpg": 1076,
	"./dogs_images/portuguese-water-dog": 1077,
	"./dogs_images/portuguese-water-dog.jpg": 1077,
	"./dogs_images/pug": 1078,
	"./dogs_images/pug.jpg": 1078,
	"./dogs_images/pugalier": 1079,
	"./dogs_images/pugalier.jpg": 1079,
	"./dogs_images/puggle": 1080,
	"./dogs_images/puggle.jpg": 1080,
	"./dogs_images/puginese": 1081,
	"./dogs_images/puginese.jpg": 1081,
	"./dogs_images/puli": 1082,
	"./dogs_images/puli.jpg": 1082,
	"./dogs_images/pyredoodle": 1083,
	"./dogs_images/pyredoodle.jpg": 1083,
	"./dogs_images/pyrenean-shepherd": 1084,
	"./dogs_images/pyrenean-shepherd.jpg": 1084,
	"./dogs_images/rat-terrier": 1085,
	"./dogs_images/rat-terrier.jpg": 1085,
	"./dogs_images/redbone-coonhound": 1086,
	"./dogs_images/redbone-coonhound.jpg": 1086,
	"./dogs_images/rhodesian-ridgeback": 1087,
	"./dogs_images/rhodesian-ridgeback.jpg": 1087,
	"./dogs_images/rottador": 1088,
	"./dogs_images/rottador.jpg": 1088,
	"./dogs_images/rottle": 1089,
	"./dogs_images/rottle.jpg": 1089,
	"./dogs_images/rottweiler": 1090,
	"./dogs_images/rottweiler.jpg": 1090,
	"./dogs_images/saint-berdoodle": 1091,
	"./dogs_images/saint-berdoodle.jpg": 1091,
	"./dogs_images/saint-bernard": 1092,
	"./dogs_images/saint-bernard.jpg": 1092,
	"./dogs_images/saluki": 1093,
	"./dogs_images/saluki.jpg": 1093,
	"./dogs_images/samoyed": 1094,
	"./dogs_images/samoyed.jpg": 1094,
	"./dogs_images/samusky": 1095,
	"./dogs_images/samusky.jpg": 1095,
	"./dogs_images/schipperke": 1096,
	"./dogs_images/schipperke.jpg": 1096,
	"./dogs_images/schnoodle": 1097,
	"./dogs_images/schnoodle.jpg": 1097,
	"./dogs_images/scottish-deerhound": 1098,
	"./dogs_images/scottish-deerhound.jpg": 1098,
	"./dogs_images/scottish-terrier": 1099,
	"./dogs_images/scottish-terrier.jpg": 1099,
	"./dogs_images/sealyham-terrier": 1100,
	"./dogs_images/sealyham-terrier.jpg": 1100,
	"./dogs_images/sheepadoodle": 1101,
	"./dogs_images/sheepadoodle.jpg": 1101,
	"./dogs_images/shepsky": 1102,
	"./dogs_images/shepsky.jpg": 1102,
	"./dogs_images/shetland-sheepdog": 1103,
	"./dogs_images/shetland-sheepdog.jpg": 1103,
	"./dogs_images/shiba-inu": 1104,
	"./dogs_images/shiba-inu.jpg": 1104,
	"./dogs_images/shichon": 1105,
	"./dogs_images/shichon.jpg": 1105,
	"./dogs_images/shih-poo": 1106,
	"./dogs_images/shih-poo.jpg": 1106,
	"./dogs_images/shih-tzu": 1107,
	"./dogs_images/shih-tzu.jpg": 1107,
	"./dogs_images/shiloh-shepherd": 1108,
	"./dogs_images/shiloh-shepherd.jpg": 1108,
	"./dogs_images/shiranian": 1109,
	"./dogs_images/shiranian.jpg": 1109,
	"./dogs_images/shollie": 1110,
	"./dogs_images/shollie.jpg": 1110,
	"./dogs_images/shorkie": 1111,
	"./dogs_images/shorkie.jpg": 1111,
	"./dogs_images/siberian-husky": 1112,
	"./dogs_images/siberian-husky.jpg": 1112,
	"./dogs_images/silken-windhound": 1113,
	"./dogs_images/silken-windhound.jpg": 1113,
	"./dogs_images/silky-terrier": 1114,
	"./dogs_images/silky-terrier.jpg": 1114,
	"./dogs_images/skye-terrier": 1115,
	"./dogs_images/skye-terrier.jpg": 1115,
	"./dogs_images/sloughi": 1116,
	"./dogs_images/sloughi.jpg": 1116,
	"./dogs_images/small-munsterlander-pointer": 1117,
	"./dogs_images/small-munsterlander-pointer.jpg": 1117,
	"./dogs_images/soft-coated-wheaten-terrier": 1118,
	"./dogs_images/soft-coated-wheaten-terrier.jpg": 1118,
	"./dogs_images/spanish-mastiff": 1119,
	"./dogs_images/spanish-mastiff.jpg": 1119,
	"./dogs_images/spinone-italiano": 1120,
	"./dogs_images/spinone-italiano.jpg": 1120,
	"./dogs_images/springador": 1121,
	"./dogs_images/springador.jpg": 1121,
	"./dogs_images/stabyhoun": 1122,
	"./dogs_images/stabyhoun.jpg": 1122,
	"./dogs_images/staffordshire-bull-terrier": 1123,
	"./dogs_images/staffordshire-bull-terrier.jpg": 1123,
	"./dogs_images/standard-schnauzer": 1124,
	"./dogs_images/standard-schnauzer.jpg": 1124,
	"./dogs_images/sussex-spaniel": 1125,
	"./dogs_images/sussex-spaniel.jpg": 1125,
	"./dogs_images/swedish-vallhund": 1126,
	"./dogs_images/swedish-vallhund.jpg": 1126,
	"./dogs_images/terripoo": 1127,
	"./dogs_images/terripoo.jpg": 1127,
	"./dogs_images/texas-heeler": 1128,
	"./dogs_images/texas-heeler.jpg": 1128,
	"./dogs_images/tibetan-mastiff": 1129,
	"./dogs_images/tibetan-mastiff.jpg": 1129,
	"./dogs_images/tibetan-spaniel": 1130,
	"./dogs_images/tibetan-spaniel.jpg": 1130,
	"./dogs_images/tibetan-terrier": 1131,
	"./dogs_images/tibetan-terrier.jpg": 1131,
	"./dogs_images/toy-fox-terrier": 1132,
	"./dogs_images/toy-fox-terrier.jpg": 1132,
	"./dogs_images/treeing-tennessee-brindle": 1133,
	"./dogs_images/treeing-tennessee-brindle.jpg": 1133,
	"./dogs_images/treeing-walker-coonhound": 1134,
	"./dogs_images/treeing-walker-coonhound.jpg": 1134,
	"./dogs_images/valley-bulldog": 1135,
	"./dogs_images/valley-bulldog.jpg": 1135,
	"./dogs_images/vizsla": 1136,
	"./dogs_images/vizsla.jpg": 1136,
	"./dogs_images/weimaraner": 1137,
	"./dogs_images/weimaraner.jpg": 1137,
	"./dogs_images/welsh-springer-spaniel": 1138,
	"./dogs_images/welsh-springer-spaniel.jpg": 1138,
	"./dogs_images/welsh-terrier": 1139,
	"./dogs_images/welsh-terrier.jpg": 1139,
	"./dogs_images/west-highland-white-terrier": 1140,
	"./dogs_images/west-highland-white-terrier.jpg": 1140,
	"./dogs_images/westiepoo": 1141,
	"./dogs_images/westiepoo.jpg": 1141,
	"./dogs_images/whippet": 1142,
	"./dogs_images/whippet.jpg": 1142,
	"./dogs_images/whoodle": 1143,
	"./dogs_images/whoodle.jpg": 1143,
	"./dogs_images/wirehaired-pointing-griffon": 1144,
	"./dogs_images/wirehaired-pointing-griffon.jpg": 1144,
	"./dogs_images/xoloitzcuintli": 1145,
	"./dogs_images/xoloitzcuintli.jpg": 1145,
	"./dogs_images/yorkipoo": 1146,
	"./dogs_images/yorkipoo.jpg": 1146,
	"./dogs_images/yorkshire-terrier": 1147,
	"./dogs_images/yorkshire-terrier.jpg": 1147,
	"./embark-dog-dna-test-kit": 1148,
	"./embark-dog-dna-test-kit.jpg": 1148,
	"./favicon": 1149,
	"./favicon.png": 1149,
	"./featured_on/barkpost": 1150,
	"./featured_on/barkpost.png": 1150,
	"./featured_on/dogster": 1151,
	"./featured_on/dogster.png": 1151,
	"./featured_on/healthypaws": 1152,
	"./featured_on/healthypaws.png": 1152,
	"./featured_on/huffpost": 1153,
	"./featured_on/huffpost.png": 1153,
	"./featured_on/rover": 1154,
	"./featured_on/rover.png": 1154,
	"./featured_on/tails": 1155,
	"./featured_on/tails.png": 1155,
	"./fishes/fish-tank-depth": 1156,
	"./fishes/fish-tank-depth.jpg": 1156,
	"./fishes/fish-tank-length": 1157,
	"./fishes/fish-tank-length.jpg": 1157,
	"./fishes/fish-tank-substrate-depth": 1158,
	"./fishes/fish-tank-substrate-depth.jpg": 1158,
	"./fishes/fish-tank-width": 1159,
	"./fishes/fish-tank-width.jpg": 1159,
	"./forbes": 1160,
	"./forbes.jpg": 1160,
	"./giphy-attribution": 1161,
	"./giphy-attribution.png": 1161,
	"./goats/Goat in active labor": 1162,
	"./goats/Goat in active labor.jpg": 1162,
	"./goats/Goat in early pregnancy": 1163,
	"./goats/Goat in early pregnancy.jpg": 1163,
	"./goats/Goat in late pregnancy": 1164,
	"./goats/Goat in late pregnancy.jpg": 1164,
	"./goats/Goat mastitis": 1165,
	"./goats/Goat mastitis.jpg": 1165,
	"./goats/Sticky tail and vulval discharge": 1166,
	"./goats/Sticky tail and vulval discharge.jpg": 1166,
	"./homepage/poll_image": 1167,
	"./homepage/poll_image.png": 1167,
	"./homepage/quiz_image": 1168,
	"./homepage/quiz_image.png": 1168,
	"./homepage/tool_image": 1169,
	"./homepage/tool_image.png": 1169,
	"./horses/Horse postpartum care": 1170,
	"./horses/Horse postpartum care.jpg": 1170,
	"./horses/Horse pregnancy 10th month": 1171,
	"./horses/Horse pregnancy 10th month.jpg": 1171,
	"./horses/Horse pregnancy 11th month": 1172,
	"./horses/Horse pregnancy 11th month.jpg": 1172,
	"./horses/Horse pregnancy 1st month": 1173,
	"./horses/Horse pregnancy 1st month.jpg": 1173,
	"./horses/Horse pregnancy 2nd month": 1174,
	"./horses/Horse pregnancy 2nd month.jpg": 1174,
	"./horses/Horse pregnancy 3rd month": 1175,
	"./horses/Horse pregnancy 3rd month.jpg": 1175,
	"./horses/Horse pregnancy 4th month": 1176,
	"./horses/Horse pregnancy 4th month.jpg": 1176,
	"./horses/Horse pregnancy 5th month": 1177,
	"./horses/Horse pregnancy 5th month.jpg": 1177,
	"./horses/Horse pregnancy 6th month": 1178,
	"./horses/Horse pregnancy 6th month.jpg": 1178,
	"./horses/Horse pregnancy 7th month": 1179,
	"./horses/Horse pregnancy 7th month.jpg": 1179,
	"./horses/Horse pregnancy 8th month": 1180,
	"./horses/Horse pregnancy 8th month.jpg": 1180,
	"./horses/Horse pregnancy 9th month": 1181,
	"./horses/Horse pregnancy 9th month.jpg": 1181,
	"./horses/Horse pregnancy in stage 2 of foaling": 1182,
	"./horses/Horse pregnancy in stage 2 of foaling.jpg": 1182,
	"./horses/Purina-Animal-Nutrition-Purina-Enrich": 1183,
	"./horses/Purina-Animal-Nutrition-Purina-Enrich.png": 1183,
	"./horses/Standlee-Hay-Company-Premium-Alfalfa-Pellet": 1184,
	"./horses/Standlee-Hay-Company-Premium-Alfalfa-Pellet.png": 1184,
	"./horses/Vita-Flex-E-and-Selenium-Supplement-for-Horses": 1185,
	"./horses/Vita-Flex-E-and-Selenium-Supplement-for-Horses.jpeg": 1185,
	"./horses/horse-weight-calculator-1": 1186,
	"./horses/horse-weight-calculator-1.jpg": 1186,
	"./horses/horse-weight-calculator-2": 1187,
	"./horses/horse-weight-calculator-2.jpg": 1187,
	"./large-dog": 1188,
	"./large-dog.png": 1188,
	"./logo": 1189,
	"./logo.png": 1189,
	"./medium-dog": 1190,
	"./medium-dog.png": 1190,
	"./nbc": 1191,
	"./nbc.jpg": 1191,
	"./pet_obesity": 1192,
	"./pet_obesity.png": 1192,
	"./pet_plate": 1193,
	"./pet_plate.jpg": 1193,
	"./providers/amazon": 1194,
	"./providers/amazon.jpg": 1194,
	"./providers/chewy": 1195,
	"./providers/chewy.jpg": 1195,
	"./puppy-weight-chart": 1196,
	"./puppy-weight-chart.png": 1196,
	"./rawwild": 1197,
	"./rawwild.jpg": 1197,
	"./shark-tank": 1198,
	"./shark-tank.jpg": 1198,
	"./small-dog": 1199,
	"./small-dog.png": 1199,
	"./smaple_puppy_weight_growth": 1200,
	"./smaple_puppy_weight_growth.jpg": 1200,
	"./swines/10 weeks pregnant swine": 1201,
	"./swines/10 weeks pregnant swine.jpg": 1201,
	"./swines/11 to 12 week pregnant swine": 1202,
	"./swines/11 to 12 week pregnant swine.jpg": 1202,
	"./swines/14 week old pig fetus": 1203,
	"./swines/14 week old pig fetus.jpg": 1203,
	"./swines/Mummified swine fetus after intrauterine death": 1204,
	"./swines/Mummified swine fetus after intrauterine death.jpg": 1204,
	"./swines/Newborn piglets nursing": 1205,
	"./swines/Newborn piglets nursing.jpg": 1205,
	"./swines/Pig embryo": 1206,
	"./swines/Pig embryo week 2": 1207,
	"./swines/Pig embryo week 2.jpg": 1207,
	"./swines/Pig embryo.jpg": 1206,
	"./swines/Pregnant swine with minimal body changes": 1208,
	"./swines/Pregnant swine with minimal body changes.jpg": 1208,
	"./swines/Swine giving birth to a piglet": 1209,
	"./swines/Swine giving birth to a piglet.jpg": 1209,
	"./swines/Swine in week 16 of pregnancy": 1210,
	"./swines/Swine in week 16 of pregnancy.jpg": 1210,
	"./v2/footer-animals": 1211,
	"./v2/footer-animals.svg": 1211,
	"./v2/header-bg-desktop": 1212,
	"./v2/header-bg-desktop.png": 1212,
	"./v2/icons/calendar": 1213,
	"./v2/icons/calendar.svg": 1213,
	"./v2/icons/carousel-dot": 1214,
	"./v2/icons/carousel-dot-active": 1215,
	"./v2/icons/carousel-dot-active.svg": 1215,
	"./v2/icons/carousel-dot.svg": 1214,
	"./v2/icons/chevron-down-green": 1216,
	"./v2/icons/chevron-down-green.svg": 1216,
	"./v2/icons/chevron-left-red": 1217,
	"./v2/icons/chevron-left-red.svg": 1217,
	"./v2/icons/chevron-right": 1218,
	"./v2/icons/chevron-right-red": 1219,
	"./v2/icons/chevron-right-red.svg": 1219,
	"./v2/icons/chevron-right.svg": 1218,
	"./v2/icons/close": 1220,
	"./v2/icons/close.svg": 1220,
	"./v2/icons/edit": 1221,
	"./v2/icons/edit.svg": 1221,
	"./v2/icons/fire": 1222,
	"./v2/icons/fire.svg": 1222,
	"./v2/icons/fyi": 1223,
	"./v2/icons/fyi.svg": 1223,
	"./v2/icons/hamburger": 1224,
	"./v2/icons/hamburger.svg": 1224,
	"./v2/icons/hamster": 1225,
	"./v2/icons/hamster.svg": 1225,
	"./v2/icons/menu-close": 1226,
	"./v2/icons/menu-close.svg": 1226,
	"./v2/icons/minus": 1227,
	"./v2/icons/minus.svg": 1227,
	"./v2/icons/mixed-dog-breed": 1228,
	"./v2/icons/mixed-dog-breed.svg": 1228,
	"./v2/icons/plus": 1229,
	"./v2/icons/plus.svg": 1229,
	"./v2/icons/progress-done": 1230,
	"./v2/icons/progress-done.svg": 1230,
	"./v2/icons/progress-off": 1231,
	"./v2/icons/progress-off.svg": 1231,
	"./v2/icons/progress-on": 1232,
	"./v2/icons/progress-on.svg": 1232,
	"./v2/icons/radio-off": 1233,
	"./v2/icons/radio-off.svg": 1233,
	"./v2/icons/radio-on": 1234,
	"./v2/icons/radio-on.svg": 1234,
	"./v2/icons/rainbow-separator": 1235,
	"./v2/icons/rainbow-separator.svg": 1235,
	"./v2/icons/useful-reads": 1236,
	"./v2/icons/useful-reads.svg": 1236,
	"./v2/logo": 1237,
	"./v2/logo-blue": 1238,
	"./v2/logo-blue.png": 1238,
	"./v2/logo.png": 1237,
	"./wave": 1239,
	"./wave.jpg": 1239,
	"./wsj": 1240,
	"./wsj.jpg": 1240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1390;